import {
  useState,
  useContext,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import inactiveBulb from "../../../Assets/Images/inactiveBulb.png";
import activeBulb from "../../../Assets/Images/activeBulb.png";
import jobsPageIcon from "../../../Assets/Images/jobs-header-icon.svg";
import JobsDarkIcon from "../../../Assets/Images/jobs-header-darkicon.svg";
import Button from "../../../Common/Button/Button";
import { useNavigate, useLocation } from "react-router-dom";
import JobsCard, { JobStatusUpdatePopup } from "../../../Common/Card/JobsCard";
import javaIcon from "../../../Assets/Images/javaIcon.png";
import gridActiveDarkIcon from "../../../Assets/Images/Grid-Active-Dark.svg";
import gridNotActiveDarkIcon from "../../../Assets/Images/Grid-NotActive-Dark.svg";
import tableActiveDarkIcon from "../../../Assets/Images/Table-Active-Dark.svg";
import tableNotActiveDarkIcon from "../../../Assets/Images/Table-NotActive-Dark.svg";
import excelIcon from "../../../Assets/Images/excelIcon.png";
import phpIcon from "../../../Assets/Images/phpIcon.png";
import reactIcon from "../../../Assets/Images/reactIcon.png";
import pythonIcon from "../../../Assets/Images/pythonIcon.png";
import androidIcon from "../../../Assets/Images/androidIcon.png";
import infoIcon from "../../../Assets/Images/infoicon.svg";
import TextInput from "../../../Common/TextInput/TextInput";
import EyeIcon from "../../../Assets/Images/Eye-Icon.svg";
import SelectInput from "../../../Common/Select-Input/SelectInput";
import DynamicTextField from "../../../Common/Textfield/Textfield";
import styled from "@emotion/styled";
import { DynamicContext } from "../../../Context/DynamicContext";
import SidePopup from "../../../Common/SidePopup/SidePopup";
import "./JobsTableList.css";
import "../../../Common/StageFilterPopup/StageFilterPopup.css";
import VendorSelectionPopup from "./VendorSelectionPopup";
import { post, get, put, deleteRequest } from "../../../helper/Api_helper";
import { STREAMING_ENABLED } from "../../../helper/featureFlags";
import { useThinkingFallback } from "../../../helper/useThinkingFallback";
import { RECOVERY_FAILED_MESSAGE } from "../../../helper/chatRecovery";
import CustomTooltip from "../../../Common/Tooltip/Tooltip";
import MatchPercentage from "../../../Common/Match-percentage-popup/MatchPercentage";
import {
  VYLABS_BASE_URL,
  JOBS_LIST,
  CREATE_JOB,
  WEB_SOCKET_URL,
  GET_CLIENTS_LIST,
  CREATE_CHAT_CHANNEL_URL,
  UPDATE_JOB,
  PROCESS_JOB_CONVERSATION,
  GET_CURRENT_CONVERSATION_TITLE,
  SEARCH_CLIENTS,
  DELETE_JOB_DETAILS,
  GET_JOB_DETAILS_BY_ID,
  SIMPLE_SEARCH_CANDIDATES,
  GET_CLIENT_DETAILS,
  JOBS_SIMPLE_SEARCH,
  LIST_MEMEBERS_OF_TENANT,
} from "../../../helper/url_helper";
import { TENANT_CORE_API_KEY } from "../../../Tenant-Config/TenantConfig";
import { Toast } from "../../../Common/Toast-Snackbar/ToastSnackbar";
import AutoComplete from "../../../Common/AutoComplete/AutoComplete";
import OptionsData from "../../../Assets/Json/StaticOptions.json";
import DynamicSkeleton from "../../../Common/Skeleton/Skeleton";
import GlobalSearchBox from "../../../Common/GlobalSearchBox/GlobalSearchBox";
import { candidatesCache, channelIdCache } from "./RecommendCandidates";
import TextArea from "../../../Common/TextArea/TextArea";
import AnimationPlayer from "../../../Common/Animation-Player/AnimationPlayer";
import RobatAnimation from "../../../Assets/Json/nodata-found-robot-animation.json";
import BotReplyIcon from "../../../Assets/Images/VybogTAL GEN Icon White.svg";
import ThinkingBubble from "../../../Common/ThinkingBubble/ThinkingBubble";
import VybogTALLoaderAnimation from "../../../Common/Dynamic-Animations/DynamicAnimations";
import rightArrowIcon from "../../../Assets/Images/arrow-right.png";
import { ConfirmationPopup, StandardPopup } from "../../../Common/PopupStyles/PopupComponent";
import JobsDetailsContainer from "../../../Common/Jobs-Details-Container/JobsDetailsContainer";
import createDarkJobIcon from "../../../Assets/Images/Create New Job Icon Dark.svg";
import DynamicAutocomplete from "../../../Common/AutoSuggestion/DynamicAutocomplete";
import CriticalIcon from "../../../Assets/Images/critical-icon.svg";
import HighIcon from "../../../Assets/Images/high-icon.svg";
import LowIcon from "../../../Assets/Images/low-icon.svg";
import MediumIcon from "../../../Assets/Images/medium-icon.svg";
import { v4 as uuidv4 } from "uuid";
import {
  applyEllipsis,
  BotResponseStarIcon,
  sanitizeBotText,
  parseMessageText,
  filterPayload,
  renderInlineMarkdown,
  getBulletContent,
  renderBotContent,
} from "../../../Common/Common-Function/CommonFunctions";
import sendIconDarkAnimation from "../../../Assets/Json/nodata-found-robot-animation.json";
import gridSelectIcon from "../../../Assets/Images/grid-selected-icon.svg";
import gridNoSelectIcon from "../../../Assets/Images/grid-icon.svg";
import tableSelectIcon from "../../../Assets/Images/tabler_table-icon.svg";
import tableNoSelectIcon from "../../../Assets/Images/tabler_table-notselect-icon.svg";
import Table from "../../../Common/Table/Table";
import networkIcon from "../../../Assets/Images/Network-badge-icon-white.svg";
import JobSimpleSearchBox from "../../../Common/Simple-Search-Box/JobSimpleSearchBox";
import VybogTALJobGenIcon from "../../../Assets/Images/VybogTAL GEN Icon White.svg";
import ToggleSwitcher from "../../../Common/Toggle-Switcher/ToggleSwitcher";
import AIJobDescriptionIcon from "../../../Assets/Images/ai-job-desc-icon.svg";
import DynamicMultipleSelectCheckmarks from "../../Multiple-Select-Checkmarks/MultipleSelectCheckmarks";
import JobFileUpload from "./JobFileUpload";
import ImportJDIcon from "../../../Assets/Images/importJD-icon.svg";
import importIcon from "../../../Assets/Images/import-blue-Icon.svg";

const { StaticOptions = {} } = OptionsData || {};
const { skills = [] } = StaticOptions || {};
const { staticJobTypes = [], priority = [] } = StaticOptions || [];
const JOB_STATUS_FILTER_LABELS = {
  active: "Active Jobs",
  inactive: "Inactive Jobs",
};
const DEFAULT_JOB_STATUS_FILTER = "active";
const JOBS_PAGE_SIZE = 10;

const getJobsPageFromOffset = (offsetValue = 0) =>
  Math.floor(Number(offsetValue || 0) / JOBS_PAGE_SIZE) + 1;

const assignedDetails = [
  { label: "Created By Me", value: "user_id" },
  { label: "Assigned To Me", value: "assigned_to" },
];

const PRIORITY_ICON_MAP = { CriticalIcon, HighIcon, MediumIcon, LowIcon };

const getPriorityData = (priorityValue) => {
  const priorityData = priority.find(
    (item) => Number(item.id ?? item.value) === Number(priorityValue),
  );

  if (!priorityData) return null;

  return {
    ...priorityData,
    icon: PRIORITY_ICON_MAP[priorityData.icon],
    name: priorityData.name || priorityData.title,
  };
};

const getPriorityLabel = (priorityValue) =>
  getPriorityData(priorityValue)?.name || "N/A";

const getJobMatchFitLabel = (matchPercentage) => {
  if (
    matchPercentage === null ||
    matchPercentage === undefined ||
    matchPercentage === ""
  ) {
    return "N/A";
  }

  const numericMatchPercentage = Number(matchPercentage);
  if (!Number.isFinite(numericMatchPercentage)) {
    return "N/A";
  }

  if (numericMatchPercentage >= 90) return "Top Fit";
  if (numericMatchPercentage >= 66) return "Good Fit";
  if (numericMatchPercentage >= 33) return "Partial Fit";
  return "Unlikely Fit";
};

const getJobMatchFitClassName = (fitLabel) =>
  `job-fit-pill job-fit-pill-${fitLabel
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "")}`;

const EMPTY_JOB_SEARCH_PARAMS = {
  job_role: "",
  job_type: "",
  location: "",
  query: "",
  skills: [],
  min_years_experience: "",
  max_years_experience: "",
  client_id: "",
  client_contact_id: "",
  user_job_relation: "",
  priority: "",
  sort_by: "",
};

const mapClientContactsToOptions = (contacts = []) =>
  Array.isArray(contacts)
    ? contacts
        .filter((contact) => contact?.id && contact?.name)
        .map((contact) => ({
          label: contact.name,
          value: contact.id,
        }))
    : [];

export const StyledGlobelSearch = styled(TextInput)({
  width: "350px",
  padding: "10px",
  marginBottom: "3px",
  border: "1px solid #ccc",
  borderRadius: "7px",
  boxSizing: "border-box",
  outline: "none",
  marginLeft: "15px",
  paddingLeft: "30px",
  "@media screen and (max-width:920px)": {
    width: "400px",
  },
  "@media screen and (max-width:768px)": {
    width: "350px",
  },
});

const FilterPill = ({ value, style, color }) => {
  const pillStyle = {
    display: "inline-block",
    ...style,
  };
  const spanStyle = {};
  if (color) {
    pillStyle.backgroundColor = `${color}25`;
    pillStyle.color = color;
    pillStyle.border = `1px solid ${color}`;
    spanStyle.color = color;
  }
  return (
    <div className="filter-pill" style={pillStyle}>
      <span className="filter-pill-value" style={spanStyle}>
        {value}
      </span>
    </div>
  );
};

const SearchFilterPills = ({
  query,
  job_role,
  job_type,
  location,
  skills,
  min_years_experience,
  max_years_experience,
}) => {
  const filters = [];

  if (query && query.trim()) {
    filters.push({ value: query, type: "query" });
  }
  if (job_role && job_role.trim()) {
    filters.push({ value: job_role, type: "job_role" });
  }
  if (job_type && job_type.trim()) {
    filters.push({ value: job_type, type: "job_type" });
  }
  if (location && location.trim()) {
    filters.push({ value: location, type: "location" });
  }
  if (Array.isArray(skills) && skills.length > 0) {
    skills.forEach((skill, index) => {
      if (skill && skill.trim()) {
        filters.push({ value: skill.trim(), type: `skill-${index}` });
      }
    });
  }
  if (min_years_experience && min_years_experience.toString().trim()) {
    filters.push({
      value: `Min: ${min_years_experience} yrs`,
      type: "min_experience",
    });
  }
  if (max_years_experience && max_years_experience.toString().trim()) {
    filters.push({
      value: `Max: ${max_years_experience} yrs`,
      type: "max_experience",
    });
  }

  return (
    <div
      style={{
        display: "flex",
        gap: "8px",
        flexWrap: "wrap",
        alignItems: "center",
        padding: "4px 0",
        justifyContent: "flex-end",
      }}
    >
      {filters.map((filter, index) => (
        <FilterPill key={`${filter.type}-${index}`} value={filter.value} />
      ))}
    </div>
  );
};

function JobsTableList() {
  const navigate = useNavigate();
  const location = useLocation();
  const observer = useRef();
  const {
    isDarkMode,
    assignedCount,
    setAssignedCount,
    userDetails,
    isVendorFeatureEnabled,
    setIsFromCandidateRecommendedJobs,
    AdminAccess,
    MemberAccess,
    isMonthlyEmailLimitReached,
    getMonthlyEmailTooltip,
    isHiringTeamTenant,
    formatDateWithUserTimezone,
  } = useContext(DynamicContext);
  const [jobsSideContainerOpen, setJobsSideContainerOpen] = useState(false);
  const [isFetchingRecommendedCandidates, setIsFetchingRecommendedCandidates] =
    useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalOpenJobGeneration, setIsModalOpenJobGeneration] =
    useState(null);
  const [activeTab, setActiveTab] = useState("Job Details");
  const [reconnectAttempts, setReconnectAttempts] = useState(0);
  const sideDialogformik = useFormik({
    initialValues: {
      linkedIn: false,
      atolla: false,
    },
  });
  const [jobsList, setJobList] = useState([]);
  const [offset, setOffset] = useState(0);
  const [socket, setSocket] = useState(null);
  const [isWebSocketOpen, setIsWebSocketOpen] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [isCreatingJob, setIsCreatingJob] = useState(false);
  const [currentFilter, setCurrentFilter] = useState(DEFAULT_JOB_STATUS_FILTER);
  const [jobsRefreshKey, setJobsRefreshKey] = useState(0);
  const [autoCompleteKey, setAutoCompleteKey] = useState(0);
  const [clientList, setClientList] = useState([]);
  const [membersList, setMembersList] = useState([]);
  const [isLoadingMembers, setIsLoadingMembers] = useState(false);
  const memberSearchDebounceRef = useRef(null);
  const memberSearchRequestIdRef = useRef(0);
  const [jobGenClient, setJobGenClient] = useState(null);
  const [jobGenClientLoading, setJobGenClientLoading] = useState(false);
  const [jobGenNoClients, setJobGenNoClients] = useState(false);
  const jobGenClientReqRef = useRef(0);
  const [simpleSearchClientList, setSimpleSearchClientList] = useState([]);
  const [simpleSearchClient, setSimpleSearchClient] = useState(null);
  const [simpleSearchClientLoading, setSimpleSearchClientLoading] =
    useState(false);
  const [simpleSearchNoClients, setSimpleSearchNoClients] = useState(false);
  const simpleSearchClientReqRef = useRef(0);
  const jobGenClientContactsReqRef = useRef(0);
  const simpleSearchClientContactsReqRef = useRef(0);
  const [messages, setMessages] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [showBackToList, setShowBackToList] = useState(false);
  const messagesEndRef = useRef(null);
  const [jobDetailsValidation, setJobDetailsValidation] = useState(null);
  const [openConversationLimitPopup, setOpenConversationLimitPopup] =
    useState(false);
  const [isChatChannelCreated, setIsChatChannelCreated] = useState(false);
  const [isFetchCompleted, setIsFetchCompleted] = useState(false);
  const [chatChannelID, setChatChannelID] = useState(null);
  const [openJobDeleteDialog, setOpenJobDeleteDialog] = useState(false);
  const [isSearchMode, setIsSearchMode] = useState(false);
  const [searchPage, setSearchPage] = useState(1);
  const [hasMoreSearchResults, setHasMoreSearchResults] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [isImportOpen, setIsImportOpen] = useState(false);
  const [JdOrXLImport, setJdOrXLImport] = useState("JD");
  const [isAssignClientOpen, setIsAssignClientOpen] = useState(false);
  const reconnectTimeoutRef = useRef(null);
  const socketRef = useRef(null);
  const responseReceivedRef = useRef(false);
  const isConnectingRef = useRef(false);
  const lastMessageRef = useRef(null);
  const messageQueueRef = useRef([]);

  const isAwaitingReply = messages.some((m) => m.isLoading);
  const resolveLoadingMessages = (text) => {
    setMessages((prev) => {
      const idx = prev.findIndex((m) => m.isLoading || m.isStreaming);
      if (idx === -1) return prev;
      const updated = [...prev];
      updated[idx] = {
        ...updated[idx],
        text,
        isLoading: false,
        isStreaming: false,
      };
      return updated;
    });
    responseReceivedRef.current = true;
  };
  useThinkingFallback({
    active: isAwaitingReply,
    getChannelId: () => chatChannelID,
    responseReceivedRef,
    onRecovered: (answer) => resolveLoadingMessages(answer),
    onExhausted: () => resolveLoadingMessages(RECOVERY_FAILED_MESSAGE),
  });

  const MAX_RECONNECT_ATTEMPTS = 5;
  const BASE_RECONNECT_DELAY = 1000;
  const PING_INTERVAL = 30000;
  const PING_TIMEOUT = 10000;
  const pingIntervalRef = useRef(null);
  const pingTimeoutRef = useRef(null);
  const [originalJobData, setOriginalJobData] = useState(null);
  const [editedJobData, setEditedJobData] = useState(null);
  const [isEditingJob, setIsEditingJob] = useState(false);
  const [allJobs, setAllJobs] = useState([]);
  const [recommendedCandidateIds, setRecommendedCandidateIds] = useState([]);
  const [trackedViewTab, setTrackedViewTab] = useState(0);
  const [createdByUserId, setCreatedByUserId] = useState("");
  const [jobTablePage, setJobTablePage] = useState(1);
  const [isSelectMode, setIsSelectMode] = useState(false);
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [isVendorSelectionOpen, setIsVendorSelectionOpen] = useState(false);
  const [hasSearchedJobs, setHasSearchedJobs] = useState(false);
  const [searchTotalJobs, setSearchTotalJobs] = useState(0);
  const [searchParams, setSearchParams] = useState(EMPTY_JOB_SEARCH_PARAMS);
  const [activeSearchParams, setActiveSearchParams] = useState(
    EMPTY_JOB_SEARCH_PARAMS,
  );
  const [clientContacts, setClientContacts] = useState([]);
  const [simpleSearchClientContacts, setSimpleSearchClientContacts] = useState(
    [],
  );
  const [isJobFilterOpen, setIsJobFilterOpen] = useState(false);
  const [showMatchPercentagePopup, setShowMatchPercentagePopup] =
    useState(false);
  const resetJobsPaginationState = useCallback(() => {
    setOffset(0);
    setJobList([]);
    setAllJobs([]);
    setHasMore(true);
    setJobTablePage(1);
    setIsSelectMode(false);
    setSelectedJobs([]);
  }, []);

  const applyJobFilters = useCallback(
    (jobStatus = "all", createdById = "") => {
      setCurrentFilter(jobStatus);
      setCreatedByUserId(createdById || "");
      if (jobStatus === "inactive") {
        setTrackedViewTab(0);
      }
      resetJobsPaginationState();
      setJobsRefreshKey((prev) => prev + 1);
    },
    [resetJobsPaginationState],
  );

  const formik = useFormik({
    initialValues: {
      title: "",
      client_id: "",
      minYearsExperience: "",
      maxYearsExperience: "",
      educationLevel: "",
      company: "",
      jobLocation: "",
      jobType: "",
      skills: [],
      jobDescription: "",
      jobRole: "",
      salary_min: "",
      salary_max: "",
      tags: [],
      languageProficiency: "",
      openings: "",
      jobPriority: "",
      assignedTo: [],
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Job Title is required"),
      jobRole: Yup.string().required("Job Role is required"),
      jobType: Yup.string().required("Job Type is required"),
      jobLocation: Yup.string().required("Job Location is required"),
      minYearsExperience: Yup.number()
        .typeError("Minimum years of experience must be a number")
        .integer("Years of experience must be an integer")
        .min(0, "Experience cannot be negative")
        .nullable()
        .required("Min years of exp is required"),
      maxYearsExperience: Yup.number()
        .typeError("Maximum years of experience must be a number")
        .integer("Years of experience must be an integer")
        .min(0, "Experience cannot be negative")
        .min(
          Yup.ref("minYearsExperience"),
          "Maximum years of experience cannot be less than minimum years of experience",
        )
        .nullable()
        .required("Max years of exp is required")
        .max(99, "Please enter a two digit number"),
      salary_min: Yup.number(),
      salary_max: Yup.number(),
      jobDescription: Yup.string().nullable(),
      jobPriority: Yup.string().nullable(),
      skills: Yup.mixed()
        .test(
          "is-array-or-string",
          "Skills must be an array or string",
          function (value) {
            return Array.isArray(value) || typeof value === "string";
          },
        )
        .required("Skills are required"),
      tags: Yup.array().nullable(),
      assignedTo: Yup.array().nullable(),
      openings: Yup.number()
        .required("Number of openings is required")
        .integer("Number of openings must be an integer")
        .min(1, "Number of openings must be at least 1")
        .typeError("Number of openings must be a number"),
    }),
  });

  const jgFormik = useFormik({
    initialValues: {
      genJobTitle: "",
      genClientID: "",
      genJobskills: "",
      genJobType: "",
      genJobRole: "",
      genMinYearsExperience: "",
      genMaxYearsExperience: "",
      genJobLocation: "",
      genJobdescription: "",
      genSalaryMin: "",
      genSalaryMax: "",
      genJobtags: "",
      genNumOp: 1,
      JobClientContactID: "",
      generateDescription: true,
      genJobPriority: "",
      genAssignedTo: [],
    },
    validationSchema: Yup.object({
      genJobTitle: Yup.string().required("Job Title is required"),
      genClientID: Yup.string().required("Client is required"),
      genJobskills: Yup.array().min(1, "Please add at least one skill"),
      genJobLocation: Yup.string().required("Job location is required"),
      genMinYearsExperience: Yup.number()
        .typeError("Year of experience must be a number")
        .integer("Years of experience must be an integer")
        .min(0, "Experience cannot be negative")
        .max(99, "Please enter a two digit number")
        .nullable()
        .required("Min years of exp is required"),
      genMaxYearsExperience: Yup.number()
        .typeError("Year of experience must be a number")
        .integer("Years of experience must be an integer")
        .min(0, "Experience cannot be negative")
        .max(99, "Please enter a two digit number")
        .nullable()
        .required("Max years of exp is required")
        .min(
          Yup.ref("genMinYearsExperience"),
          "Max exp cannot be less than min exp",
        ),
      genSalaryMin: Yup.number()
        .typeError("Minimum salary must be a number")
        .nullable(),
      genSalaryMax: Yup.number()
        .typeError("Maximum salary must be a number")
        .nullable(),
      genJobtags: Yup.array(),
      genJobRole: Yup.string().required("Job Role is required"),
      genJobType: Yup.string().required("Job Type is required"),
      genJobPriority: Yup.string().required("Job Priority is required"),
      genAssignedTo: Yup.array().nullable(),
      genNumOp: Yup.number()
        .typeError("Number of openings must be a number")
        .integer("Number of openings must be an integer")
        .min(1, "Number of openings must be at least 1")
        .nullable()
        .required("Number of openings is required"),
    }),
  });

  const jgFormikRef = useRef(jgFormik);
  jgFormikRef.current = jgFormik;
  const formikRef = useRef(formik);
  formikRef.current = formik;

  const defaultClientIdFormik = useFormik({
    initialValues: {
      defaultClientId: ""
    }
  });

  console.log("defaultClientIdFormik.values.defaultClientId",defaultClientIdFormik.values.defaultClientId);

  const fetchRecommendedCandidates = useCallback(async (jobId) => {
    try {
      setIsFetchingRecommendedCandidates(true);
      const jobRes = await get(
        VYLABS_BASE_URL,
        `${GET_JOB_DETAILS_BY_ID}?id=${jobId}`,
      );
      const job = jobRes?.job;

      if (!job) {
        console.error("Failed to fetch job details for recommendations");
        candidatesCache.set(jobId, []);
        setIsFetchingRecommendedCandidates(false);
        return [];
      }
      let skillsArray = [];
      if (Array.isArray(job.skills)) {
        skillsArray = job.skills;
      } else if (typeof job.skills === "string") {
        skillsArray = job.skills
          .split(",")
          .map((skill) => skill.trim())
          .filter((skill) => skill !== "");
      }

      const payload = {
        limit: 100,
        job_role: job.job_role || "",
        description: job.description || "",
        location: job.location || "",
        rerank: true,
        job_id: jobId,
      };
      if (job.years_experience !== null && job.years_experience !== undefined) {
        const yearsExp = parseInt(job.years_experience, 10);

        if (!isNaN(yearsExp)) {
          payload.min_years_of_experience = yearsExp;
        }
      }
      Object.keys(payload).forEach((key) => {
        if (
          payload[key] === "" ||
          payload[key] === null ||
          payload[key] === undefined ||
          (Array.isArray(payload[key]) && payload[key].length === 0)
        ) {
          delete payload[key];
        }
      });

      const response = await post(
        VYLABS_BASE_URL,
        SIMPLE_SEARCH_CANDIDATES,
        payload,
      );

      if (
        !response ||
        !response.candidates ||
        response.candidates.length === 0
      ) {
        candidatesCache.set(jobId, []);
        setIsFetchingRecommendedCandidates(false);
        return [];
      }

      const detailedCandidates = response.candidates.map((candidate) => ({
        ...candidate,
        parsed_resume:
          typeof candidate.parsed_resume === "string"
            ? JSON.parse(candidate.parsed_resume || "{}")
            : candidate.parsed_resume || {},
        isFileBased: false,
      }));

      candidatesCache.set(jobId, detailedCandidates);
      setIsFetchingRecommendedCandidates(false);
      return detailedCandidates;
    } catch (err) {
      console.error("Error fetching recommended candidates:", err);
      setIsFetchingRecommendedCandidates(false);
      candidatesCache.set(jobId, []);
      return [];
    }
  }, []);
  const fetchJobsList = useCallback(async (jobs = [], botMessageId) => {
    const detailedJobs = await Promise.all(
      jobs.map(async (job) => {
        try {
          const res = await get(
            VYLABS_BASE_URL,
            `${GET_JOB_DETAILS_BY_ID}?id=${job.id}`,
          );
          return res.job || null;
        } catch (err) {
          console.error("Error fetching job by ID:", err);
          return null;
        }
      }),
    );
    const filteredJobs = detailedJobs.filter(Boolean);

    setJobList(filteredJobs);
    setHasMore(filteredJobs.length === 10);

    setMessages((prev) => {
      const updated = [...prev];
      const botMessageIndex = updated.findIndex(
        (msg) => msg.id === botMessageId && msg.sender === "bot",
      );

      if (botMessageIndex !== -1) {
        updated[botMessageIndex] = {
          ...updated[botMessageIndex],
          isLoading: false,
          jobs: filteredJobs,
        };
      }

      return updated;
    });
    setIsInitialLoading(false);
    setShowBackToList(true);
  }, []);
  const initializeWebSocket = useCallback(() => {
    if (isConnectingRef.current) {
      console.log("Already attempting to connect, skipping...");
      return;
    }

    isConnectingRef.current = true;
    if (socketRef.current) {
      socketRef.current.close();
    }
    if (pingIntervalRef.current) {
      clearInterval(pingIntervalRef.current);
      pingIntervalRef.current = null;
    }
    if (pingTimeoutRef.current) {
      clearTimeout(pingTimeoutRef.current);
      pingTimeoutRef.current = null;
    }
    if (reconnectTimeoutRef.current) {
      clearTimeout(reconnectTimeoutRef.current);
      reconnectTimeoutRef.current = null;
    }
    responseReceivedRef.current = false;

    const token = localStorage.getItem("token");
    const wsProtocol =
      window.location.protocol === "https:" ? "wss://" : "wss://";
    const wsUrl = `${wsProtocol}${WEB_SOCKET_URL}/ws?token=${encodeURIComponent(
      "Bearer " + token,
    )}`;

    try {
      console.log("Creating new WebSocket connection...");
      const ws = new WebSocket(wsUrl);
      socketRef.current = ws;
      setSocket(ws);

      ws.onopen = () => {
        console.log("WebSocket connection established");
        setIsWebSocketOpen(true);
        isConnectingRef.current = false;
        if (lastMessageRef.current) {
          console.log("Resending last message:", lastMessageRef.current);
          ws.send(lastMessageRef.current);
        }
        if (messageQueueRef.current.length > 0) {
          console.log(
            `Processing ${messageQueueRef.current.length} queued messages`,
          );
          messageQueueRef.current.forEach((msg) => {
            if (ws.readyState === WebSocket.OPEN) {
              ws.send(msg);
            }
          });
          messageQueueRef.current = [];
        }
        startPingInterval(ws);
      };

      ws.onmessage = (event) => {
        console.log("WebSocket Message Received:", event.data);
        if (event.data === "pong") {
          console.log("Pong received");
          if (pingTimeoutRef.current) {
            clearTimeout(pingTimeoutRef.current);
            pingTimeoutRef.current = null;
          }
          return;
        }

        try {
          const separatorIndex = event.data.indexOf("|");
          const topic = event.data.substring(0, separatorIndex);
          const payload = event.data.substring(separatorIndex + 1);
          const trimmedTopic = topic.split(":")[0].trim();
          console.log("Parsed topic:", topic, "Trimmed topic:", trimmedTopic);

          const parseNestedJSON = (str) => {
            try {
              if (str === "reading message" || str === '"reading message"') {
                return null;
              }
              return JSON.parse(
                str
                  .replace(/^"+|"+$/g, "")
                  .replace(/\\"/g, '"')
                  .replace(/\\\\/g, "\\"),
              );
            } catch (error) {
              return {};
            }
          };
          const response = parseNestedJSON(payload);

          setMessages((prev) => {
            const updated = [...prev];
            const loadingIndex = updated.findIndex(
              (msg) => msg.isLoading || msg.isStreaming,
            );

            if (trimmedTopic === "screening-message-delta") {
              if (!STREAMING_ENABLED) return updated;
              let chunk = "";
              try {
                chunk = JSON.parse(payload);
              } catch (e) {
                chunk = payload;
              }
              if (typeof chunk !== "string") {
                chunk = chunk == null ? "" : String(chunk);
              }
              if (loadingIndex !== -1 && chunk) {
                updated[loadingIndex] = {
                  ...updated[loadingIndex],
                  text: (updated[loadingIndex].text || "") + chunk,
                  isLoading: false,
                  isStreaming: true,
                };
              }
              return updated;
            }

            if (trimmedTopic === "screening-send-message-completed") {
              console.log("Screening message completed:", response);
              responseReceivedRef.current = true;

              if (response && response.answer) {
                const lines = response.answer.split("\n");
                const jobs = lines.reduce((arr, line) => {
                  const match = line.match(
                    /-\s*(.*?)\s*\(ID:\s*([a-f0-9-]+)\)/i,
                  );
                  if (match) {
                    arr.push({ title: match[1].trim(), id: match[2].trim() });
                  }
                  return arr;
                }, []);
                if (loadingIndex !== -1) {
                  const cleanedText = sanitizeBotText(response.answer);
                  updated[loadingIndex] = {
                    ...updated[loadingIndex],
                    text: cleanedText,
                    isLoading: false,
                    isStreaming: false,
                    jobs,
                  };
                  if (jobs.length > 0) {
                    fetchJobsList(jobs, updated[loadingIndex].id);
                  } else {
                    setIsInitialLoading(false);
                    setShowBackToList(true);
                  }
                }
              } else {
                if (loadingIndex !== -1) {
                  updated[loadingIndex] = {
                    ...updated[loadingIndex],
                    isLoading: false,
                  };
                }
                setIsInitialLoading(false);
                setShowBackToList(true);
              }
            } else if (trimmedTopic === "screening-total-tokens-err") {
              console.log("Token limit exceeded:", response);
              if (loadingIndex !== -1) {
                updated[loadingIndex] = {
                  ...updated[loadingIndex],
                  text: response.message || "Token limit exceeded.",
                  isLoading: false,
                };
              }
              setIsInitialLoading(false);
              setShowBackToList(true);
            }
            if (
              trimmedTopic === "screening-send-message-completed" ||
              trimmedTopic === "screening-total-tokens-err"
            ) {
              console.log("Closing WebSocket after receiving response...");
              ws.close(1000, "Response received");
              setIsWebSocketOpen(false);
              if (pingIntervalRef.current) {
                clearInterval(pingIntervalRef.current);
                pingIntervalRef.current = null;
              }
              if (pingTimeoutRef.current) {
                clearTimeout(pingTimeoutRef.current);
                pingTimeoutRef.current = null;
              }
            }

            return updated;
          });
        } catch (error) {
          console.error("Error parsing WebSocket message:", error);
          setIsInitialLoading(false);
          ws.close(1000, "Error parsing message");
        }
      };

      ws.onclose = (event) => {
        console.log("WebSocket connection closed", event);
        setIsWebSocketOpen(false);
        isConnectingRef.current = false;
        if (pingIntervalRef.current) {
          clearInterval(pingIntervalRef.current);
          pingIntervalRef.current = null;
        }
        if (pingTimeoutRef.current) {
          clearTimeout(pingTimeoutRef.current);
          pingTimeoutRef.current = null;
        }
        if (
          event.code === 1006 ||
          (!responseReceivedRef.current && event.code !== 1000)
        ) {
          console.log(
            `Connection closed with code ${event.code}, attempting to reconnect...`,
          );
          handleReconnect();
        } else {
          setIsInitialLoading(false);
        }
      };

      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
        isConnectingRef.current = false;
        handleReconnect();
      };
    } catch (error) {
      console.error("Error creating WebSocket:", error);
      isConnectingRef.current = false;
      handleReconnect();
    }
  }, [fetchJobsList]);

  const startPingInterval = useCallback((ws) => {
    if (pingIntervalRef.current) {
      clearInterval(pingIntervalRef.current);
    }
    if (ws.readyState === WebSocket.OPEN) {
      console.warn("Sending initial ping");
      ws.send("ping");
      pingTimeoutRef.current = setTimeout(() => {
        console.log("No pong received within timeout, reconnecting...");
        ws.close(1000, "Ping timeout");
      }, PING_TIMEOUT);
    }
    pingIntervalRef.current = setInterval(() => {
      if (ws.readyState === WebSocket.OPEN) {
        console.warn("Sending ping");
        ws.send("ping");
        if (pingTimeoutRef.current) {
          clearTimeout(pingTimeoutRef.current);
        }
        pingTimeoutRef.current = setTimeout(() => {
          console.log("No pong received within timeout, reconnecting...");
          ws.close(1000, "Ping timeout");
        }, PING_TIMEOUT);
      }
    }, PING_INTERVAL);
  }, []);

  const handleReconnect = useCallback(() => {
    if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
      setIsInitialLoading(false);
      return;
    }
    const delay = Math.min(
      BASE_RECONNECT_DELAY * Math.pow(2, reconnectAttempts + 1) +
        Math.random() * 1000,
      60000,
    );

    reconnectTimeoutRef.current = setTimeout(() => {
      setReconnectAttempts((prev) => prev + 1);
      initializeWebSocket();
    }, delay);
  }, [reconnectAttempts]);

  const handleSearch = async () => {
    if (!searchQuery?.trim()) {
      Toast("error", "Please enter a search query.");
      return;
    }
    setHasSearched(true);
    setShowBackToList(false);
    setIsInitialLoading(true);

    const messageId = uuidv4();
    const botMessageId = uuidv4();
    setMessages((prev) => [
      ...prev,
      {
        id: messageId,
        sender: "user",
        text: searchQuery,
      },
      {
        id: botMessageId,
        sender: "bot",
        text: "",
        isLoading: true,
      },
    ]);

    try {
      let channelID = chatChannelID;

      if (!channelID || channelID === "null" || channelID === "undefined") {
        const createChatChannelResponse = await post(
          VYLABS_BASE_URL,
          CREATE_CHAT_CHANNEL_URL,
          { chat_channel_type: "job" },
        );
        channelID = createChatChannelResponse.ID;
        setChatChannelID(channelID);
        setIsChatChannelCreated(true);
        await post(VYLABS_BASE_URL, GET_CURRENT_CONVERSATION_TITLE, {
          chat_channel_id: channelID,
          message: searchQuery,
        });
      }

      const formData = new FormData();
      formData.append("channel_id", channelID);
      formData.append("message_content", searchQuery);

      await post(VYLABS_BASE_URL, PROCESS_JOB_CONVERSATION, formData);
      initializeWebSocket();

      setSearchQuery("");
    } catch (error) {
      console.error("Error in job conversation:", error);
      if (
        error.response?.data &&
        error.response.data.includes("chat channel is blocked")
      ) {
        setMessages((prev) =>
          prev.filter((msg) => msg.id !== messageId && msg.id !== botMessageId),
        );
        setOpenConversationLimitPopup(true);
        setIsInitialLoading(false);
      } else {
        setMessages((prev) => {
          const updated = [...prev];
          const loadingIndex = updated.findIndex((msg) => msg.isLoading);
          if (loadingIndex !== -1) {
            updated[loadingIndex] = {
              ...updated[loadingIndex],
              text: "Error processing request. Please try again.",
              isLoading: false,
            };
          }
          return updated;
        });
        setIsInitialLoading(false);
      }
    }
  };

  const handleJobSimpleSearch = async (
    page = 1,
    append = false,
    paramsOverride = null,
    pageSizeOverride = null,
  ) => {
    try {
      if (page === 1) {
        setIsInitialLoading(true);
        setIsSearchMode(true);
        setSearchPage(1);
        setJobTablePage(1);
        setActiveSearchParams({ ...(paramsOverride || searchParams) });
      } else {
        setIsLoadingMore(true);
      }
      const currentParams =
        paramsOverride || (page === 1 ? searchParams : activeSearchParams);
      const limit = pageSizeOverride || 10;
      const payload = {
        active_only: true,
        limit,
        page,
      };
      if (currentParams.query && currentParams.query.trim()) {
        payload.query = currentParams.query.trim();
      }
      if (currentParams.job_role && currentParams.job_role.trim()) {
        payload.job_role = currentParams.job_role.trim();
      }
      if (currentParams.job_type && currentParams.job_type.trim()) {
        payload.job_type = currentParams.job_type.trim();
      }
      if (currentParams.location && currentParams.location.trim()) {
        payload.location = currentParams.location.trim();
      }
      if (currentParams.sort_by === "priority") {
        payload.sort_by = "priority";
      }
      if (currentParams.priority && currentParams.priority.toString().trim()) {
        const priority = Number(currentParams.priority);
        if (!Number.isNaN(priority)) {
          payload.priority = priority;
        }
      }
      if (currentParams.skills && currentParams.skills.length > 0) {
        const nonEmptySkills = currentParams.skills
          .filter((skill) => skill && skill.trim())
          .map((skill) => skill.trim());

        if (nonEmptySkills.length > 0) {
          payload.skills = nonEmptySkills;
        }
      }

      if (
        currentParams.min_years_experience &&
        currentParams.min_years_experience.toString().trim()
      ) {
        const minExp = parseInt(currentParams.min_years_experience, 10);
        if (!isNaN(minExp)) {
          payload.min_years_experience = minExp;
        }
      }
      if (
        currentParams.max_years_experience &&
        currentParams.max_years_experience.toString().trim()
      ) {
        const maxExp = parseInt(currentParams.max_years_experience, 10);
        if (!isNaN(maxExp)) {
          payload.max_years_experience = maxExp;
        }
      }
      if (
        currentParams.client_id &&
        currentParams.client_id.toString().trim()
      ) {
        const clientId = currentParams.client_id;
        payload.client_id = clientId;
      }
      if (
        currentParams.client_contact_id &&
        currentParams.client_contact_id.toString().trim()
      ) {
        payload.client_contact_id = currentParams.client_contact_id;
      }
      if (currentParams.user_id && currentParams.user_id.toString().trim()) {
        payload.user_id = currentParams.user_id;
      }
      if (
        currentParams.assigned_to &&
        currentParams.assigned_to.toString().trim()
      ) {
        payload.assigned_to = currentParams.assigned_to;
      }
      if (
        currentParams.user_job_relation &&
        currentParams.user_job_relation.toString().trim() &&
        userDetails?.id
      ) {
        payload[currentParams.user_job_relation] = userDetails.id;
      }

      const res = await post(VYLABS_BASE_URL, JOBS_SIMPLE_SEARCH, payload);
      if (res && res.jobs) {
        if (append) {
          setJobList((prev) => [...prev, ...res.jobs]);
        } else {
          setJobList(res.jobs);
        }
        setSearchTotalJobs(res.total_jobs || res.jobs.length || 0);
        setHasSearchedJobs(true);
        const hasMoreResults = res.has_more ?? res.jobs.length === limit;
        setHasMoreSearchResults(hasMoreResults);
        setHasMore(hasMoreResults);
        setSearchPage(page);
        setOffset(0);
      }
    } catch (error) {
      console.error("handleJobSimpleSearch error:", error);
      Toast("error", error.response?.data?.message || "Failed to search jobs");
    } finally {
      setIsInitialLoading(false);
      setIsLoadingMore(false);
    }
  };

  const loadMoreSearchResults = async () => {
    if (!hasMoreSearchResults || isLoadingMore) return;
    const nextPage = searchPage + 1;
    await handleJobSimpleSearch(nextPage, true);
  };
  const handleOpenIJobGeneration = () => {
    setIsModalOpenJobGeneration(true);
    jgFormik.resetForm();
    jgFormik.setFieldValue("genJobtags", []);
    jgFormik.setFieldValue("genJobskills", []);
    setAutoCompleteKey((prev) => prev + 1);
  };
  useEffect(() => {
    if (isEditingJob && activeTab !== "Job Details") {
      setActiveTab("Job Details");
    }
  }, [isEditingJob]);

  const handleOpenJobsSideContainer = useCallback(async (job, index, tab) => {
    if (!job) return;
    setJobsSideContainerOpen(true);
    setActiveTab(tab);
    setIsFromCandidateRecommendedJobs(hasSearched);
    try {
      const jobRes = await get(
        VYLABS_BASE_URL,
        `${GET_JOB_DETAILS_BY_ID}?id=${job.id}`,
      );
      let detailedJob = jobRes?.job || job;
      if (detailedJob?.client_id && !detailedJob?.client?.contact_person) {
        try {
          const clientRes = await get(
            VYLABS_BASE_URL,
            `${GET_CLIENT_DETAILS}/?id=${detailedJob.client_id}`,
          );
          if (clientRes?.client) {
            detailedJob.client = clientRes.client;
          }
        } catch (err) {
          console.warn("Could not fetch client details:", err);
        }
      }
      setSelectedJob({ ...detailedJob, index });
      const candidates = await fetchRecommendedCandidates(job.id);
      setRecommendedCandidateIds(candidates.map((candidate) => candidate.id));
    } catch (err) {
      console.error("Error fetching job details:", err);
      setSelectedJob({ ...job, index });
      const candidates = await fetchRecommendedCandidates(job.id);
      setRecommendedCandidateIds(candidates.map((candidate) => candidate.id));
    } finally {
      setIsInitialLoading(false);
    }
  });

  const handleCloseJobsSideContainer = () => {
    setJobsSideContainerOpen(false);
    setIsFromCandidateRecommendedJobs(false);
    setSelectedJob(null);
    setActiveTab(null);
    if (selectedJob?.id) {
      candidatesCache.delete(selectedJob.id);
      channelIdCache.delete(selectedJob.id);
    }
    resetJobEdit();
  };
  const formatMembers = useCallback((response) => {
    const rawList = Array.isArray(response?.users) ? response.users : [];

    return rawList
      .filter((item) => item?.user || item?.id)
      .map((item) => {
        const u = item?.user || item;
        const name =
          [u?.first_name, u?.last_name].filter(Boolean).join(" ") || "N/A";
        return {
          ...u,
          label: name,
          value: u?.id,
          user: item?.user ? item : { user: u },
        };
      });
  }, []);

  const fetchAllMembers = useCallback(
    async (filterValue = "") => {
      if (!userDetails?.tenant_id) {
        setMembersList([]);
        return [];
      }

      const trimmedFilter =
        typeof filterValue === "string" ? filterValue.trim() : "";
      const requestId = ++memberSearchRequestIdRef.current;

      try {
        setIsLoadingMembers(true);
        const query = trimmedFilter
          ? `${LIST_MEMEBERS_OF_TENANT}?tenant_id=${userDetails.tenant_id}&filter=${encodeURIComponent(
              trimmedFilter,
            )}&offset=0&limit=30`
          : `${LIST_MEMEBERS_OF_TENANT}?tenant_id=${userDetails.tenant_id}&offset=0&limit=30`;

        const response = await get(VYLABS_BASE_URL, query, {
          headers: { "X-API-Key": TENANT_CORE_API_KEY },
        });
        if (requestId !== memberSearchRequestIdRef.current) return [];

        const formattedMembers = formatMembers(response);
        const selected = [
          ...(jgFormikRef.current?.values?.genAssignedTo || []),
          ...(formikRef.current?.values?.assignedTo || []),
        ];
        setMembersList((currentMembers) => {
          if (!selected.length) return formattedMembers;

          const missingSelected = currentMembers.filter(
            (m) =>
              m?.value &&
              selected.some((sId) => String(sId) === String(m.value)) &&
              !formattedMembers.some(
                (fm) => String(fm.value) === String(m.value),
              ),
          );
          return [...missingSelected, ...formattedMembers];
        });

        return formattedMembers;
      } catch (err) {
        console.error("Job generation: error fetching members:", err);
        return [];
      } finally {
        if (requestId === memberSearchRequestIdRef.current) {
          setIsLoadingMembers(false);
        }
      }
    },
    [formatMembers, userDetails?.tenant_id],
  );

  const handleRecruiterSearch = useCallback(
    (searchTerm) => {
      const query = (searchTerm || "").trim();

      if (memberSearchDebounceRef.current) {
        clearTimeout(memberSearchDebounceRef.current);
        memberSearchDebounceRef.current = null;
      }

      if (!query) {
        fetchAllMembers("");
        return;
      }

      memberSearchDebounceRef.current = setTimeout(() => {
        fetchAllMembers(query);
      }, 300);
    },
    [fetchAllMembers],
  );

  const handleAssignedToChange = useCallback((value) => {
    const ids = Array.isArray(value)
      ? value.filter(
          (v) => v !== undefined && v !== null && v !== "" && v !== "All",
        )
      : [];
    jgFormik.setFieldValue("genAssignedTo", ids);
  }, []);

  const handleJobAssignedToChange = useCallback((value) => {
    const ids = Array.isArray(value)
      ? value.filter(
          (v) => v !== undefined && v !== null && v !== "" && v !== "All",
        )
      : [];
    formikRef.current.setFieldValue("assignedTo", ids);
  }, []);

  const recruiterMultiSelectOptions = useMemo(
    () => membersList.filter((member) => member?.label && member?.value),
    [membersList],
  );

  useEffect(() => {
    if (isModalOpenJobGeneration) {
      fetchAllMembers("");
    }
    return () => {
      if (memberSearchDebounceRef.current) {
        clearTimeout(memberSearchDebounceRef.current);
        memberSearchDebounceRef.current = null;
      }
    };
  }, [isModalOpenJobGeneration, fetchAllMembers]);

  const handleCloseJobGeneration = () => {
    jgFormik.resetForm();
    jgFormik.setFieldValue("genJobtags", []);
    jgFormik.setFieldValue("genAssignedTo", []);
    setAutoCompleteKey((prev) => prev + 1);
    setClientList([]);
    setMembersList([]);
    setJobGenClient(null);
    setIsModalOpenJobGeneration(false);
    navigate(location.pathname, { replace: true, state: {} });
  };

  const jobIcons = [
    androidIcon,
    pythonIcon,
    reactIcon,
    phpIcon,
    excelIcon,
    javaIcon,
  ];

  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const HandleViewCell = ({ row, onView }) => {
    const handleViewClick = (event) => {
      event.stopPropagation();
      onView(row, null, "Job Details");
    };

    return (
      <div className="job-table-action-cell">
        <CustomTooltip title="View Job" arrow>
          <Button
            type="button"
            className="job-table-view-button"
            event={handleViewClick}
            backgroundColor="transparent"
            border="none"
            color="inherit"
            hoverd={false}
            aria-label={`View ${row.title || "job"}`}
          >
            <img src={EyeIcon} alt="view job" />
          </Button>
        </CustomTooltip>
      </div>
    );
  };

  const resetJobSearchState = useCallback(() => {
    setSearchQuery("");
    setSearchParams({ ...EMPTY_JOB_SEARCH_PARAMS, skills: [] });
    setActiveSearchParams({ ...EMPTY_JOB_SEARCH_PARAMS, skills: [] });
    setSimpleSearchClientList([]);
    setSimpleSearchClient(null);
    setSimpleSearchClientContacts([]);
    setHasSearchedJobs(false);
    setIsSearchMode(false);
    setSearchPage(1);
    setJobTablePage(1);
    setSearchTotalJobs(0);
    setHasMoreSearchResults(false);
    setIsJobFilterOpen(false);
  }, []);

  const handleBackToList = () => {
    setHasSearched(false);
    setShowBackToList(false);
    setMessages([]);
    resetJobSearchState();
    setIsChatChannelCreated(false);
    setChatChannelID(null);
    setOffset(0);
    setIsSelectMode(false);
    setSelectedJobs([]);
    setJobsRefreshKey((prev) => prev + 1);
    if (socketRef.current) {
      socketRef.current.close(1000, "Back to Jobs List");
      socketRef.current = null;
    }
    setIsWebSocketOpen(false);
    setSocket(null);
  };

  const handleClearSearchForm = () => {
    resetJobSearchState();
    applyJobFilters(DEFAULT_JOB_STATUS_FILTER, "");
  };

  const renderCepheaLoader = () => (
    <div
      className="cephea-loader-container"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "10px",
        width: "100%",
        marginBottom: "15px",
      }}
    >
      <VybogTALLoaderAnimation />
    </div>
  );

  const jobDetails = {
    title: selectedJob?.title,
    skills: selectedJob?.skills || "",
    description: selectedJob?.description,
    job_type: selectedJob?.job_type,
    location: selectedJob?.location,
    years_experience: selectedJob?.years_experience,
    salary_min: selectedJob?.salary_min,
    salary_max: selectedJob?.salary_max,
    tags: selectedJob?.tags,
  };

  const assignedCountChange = useCallback(
    (count) => {
      setAssignedCount(count);
    },
    [setAssignedCount],
  );

  useEffect(() => {
    if (location.state?.openCreateJob) {
      handleOpenIJobGeneration();
    }
  }, [location.state]);

  const fetchJobs = async (customOffset = 0, createdById = createdByUserId) => {
    try {
      if (customOffset === 0) {
        setIsInitialLoading(true);
      } else {
        setIsLoadingMore(true);
      }

      const payload = {
        limit: JOBS_PAGE_SIZE,
        status: true,
        page: getJobsPageFromOffset(customOffset),
      };

      if (createdById) {
        payload.user_id = createdById;
      }

      const response = await post(VYLABS_BASE_URL, JOBS_LIST, payload);

      const { jobs = [] } = response;
      const fetchedJobs = Array.isArray(jobs)
        ? jobs
            .filter((job) => job?.id)
            .map((job) => ({
              ...job,
              tags: job.tags || [],
              skills: job.skills || "",
              description: job.description || "",
              title: job.title || "",
              job_role: job.job_role || "",
              client_id: job.client_id || "",
            }))
        : [];

      if (customOffset === 0) {
        setJobList(fetchedJobs);
        setAllJobs(fetchedJobs);
      } else {
        setJobList((prev = []) => {
          const merged = [...prev, ...fetchedJobs];
          const unique = (merged || []).filter(
            (item, index, self) =>
              index === self.findIndex((x) => x.id === item.id),
          );
          return unique;
        });

        setAllJobs((prev = []) => {
          const merged = [...prev, ...fetchedJobs];
          const unique = (merged || []).filter(
            (item, index, self) =>
              index === self.findIndex((x) => x.id === item.id),
          );
          return unique;
        });
      }

      setHasMore(fetchedJobs.length === JOBS_PAGE_SIZE);
    } catch (error) {
      console.error("Error fetching jobs:", error);
    } finally {
      setIsInitialLoading(false);
      setIsLoadingMore(false);
      setIsFetchCompleted(true);
    }
  };

  const fetchJobsByStatus = async (
    jobStatus,
    customOffset = offset,
    createdById = createdByUserId,
  ) => {
    if (jobStatus === "") {
      return;
    }
    try {
      if (customOffset === 0) {
        setIsInitialLoading(true);
      } else {
        setIsLoadingMore(true);
      }
      const payload = {
        limit: JOBS_PAGE_SIZE,
        status: jobStatus === "active",
        page: getJobsPageFromOffset(customOffset),
      };

      if (createdById) {
        payload.user_id = createdById;
      }

      const response = await post(VYLABS_BASE_URL, JOBS_LIST, payload);

      const { jobs = [] } = response;
      const fetchedJobs = Array.isArray(jobs)
        ? jobs
            .filter((job) => job?.id)
            .map((job) => ({
              ...job,
              tags: job.tags || [],
              skills: job.skills || "",
              description: job.description || "",
              title: job.title || "",
              job_role: job.job_role || "",
              client_id: job.client_id || "",
            }))
        : [];

      setJobList((prev = []) => {
        if (customOffset === 0) {
          return fetchedJobs;
        } else {
          const existingJobs = new Map();
          (prev || []).forEach((job) => {
            if (job?.id) existingJobs.set(job.id, job);
          });
          fetchedJobs.forEach((job) => {
            if (job?.id) existingJobs.set(job.id, job);
          });
          return Array.from(existingJobs.values());
        }
      });
      setAllJobs((prev = []) => {
        if (customOffset === 0) {
          return fetchedJobs;
        }

        const existingJobsMap = new Map();
        (prev || []).forEach((job) => {
          if (job?.id) existingJobsMap.set(job.id, job);
        });

        fetchedJobs.forEach((job) => {
          if (job?.id) existingJobsMap.set(job.id, job);
        });

        return Array.from(existingJobsMap.values());
      });
      setHasMore(fetchedJobs.length === JOBS_PAGE_SIZE);
    } catch (err) {
      console.error("GET JOBS_LIST error", err);
    } finally {
      setIsInitialLoading(false);
      setIsLoadingMore(false);
      setIsFetchCompleted(true);
    }
  };

  useEffect(() => {
    if (isSearchMode) return;
    const shouldFetch =
      currentFilter === "all" ||
      Boolean(JOB_STATUS_FILTER_LABELS[currentFilter]);

    if (shouldFetch) {
      if (currentFilter === "all") {
        fetchJobs(offset);
      } else {
        fetchJobsByStatus(currentFilter, offset);
      }
    }
  }, [offset, currentFilter, isSearchMode, createdByUserId, jobsRefreshKey]);

  const handleSimpleSearchSubmit = (submittedSearchParams = null) => {
    handleJobSimpleSearch(1, false, submittedSearchParams);
  };
  const handleViewJobTable = () => {
    if (trackedViewTab !== 1) {
      resetJobSearchState();
    }
    setTrackedViewTab(1);
    setJobTablePage(1);
    setOffset(0);
    if (hasSearchedJobs || isSearchMode) {
      setJobsRefreshKey((prev) => prev + 1);
    }
  };

  const handleViewJobGrid = () => {
    if (trackedViewTab !== 0) {
      resetJobSearchState();
    }
    setTrackedViewTab(0);
    setOffset(0);
    if (hasSearchedJobs || isSearchMode) {
      setJobsRefreshKey((prev) => prev + 1);
    }
  };

  useEffect(() => {
    if (
      trackedViewTab === 1 &&
      !isSearchMode &&
      jobsList.length > 0 &&
      jobsList.length <= 10 &&
      hasMore
    ) {
      setOffset((prev) => Math.max(prev, 10));
    }
  }, [trackedViewTab, isSearchMode]);

  const generateJobDescription = async (e) => {
    if (isGenerating) return;
    setIsGenerating(true);
    await jgFormik.validateForm();
    if (!jgFormik.isValid || Object.keys(jgFormik.touched).length === 0) {
      jgFormik.setTouched({
        genJobTitle: true,
        genClientID: true,
        genJobLocation: true,
        genJobRole: true,
        genJobType: true,
        genMinYearsExperience: true,
        genMaxYearsExperience: true,
        genSalaryMin: true,
        genSalaryMax: true,
        // genJobtags: true,
        // genJobdescription: true,
        genJobskills: true,
        genNumOp: true,
      });
      Object.keys(jgFormik.errors).forEach((key) => {
        Toast("error", jgFormik.errors[key]);
      });
      return;
    }
    if (jgFormik.values.genJobskills.length === 0) {
      jgFormik.setFieldTouched("genJobskills", true);
      Toast("error", "Please select at least one skill");
      return;
    }

    try {
      setIsCreatingJob(true);
      setIsWebSocketOpen(true);
      setIsInitialLoading(true);
      setIsFetchCompleted(false);
      const jobTitle = jgFormik.values.genJobTitle;
      const rawPayload = {
        title: jobTitle,
        clientID: jgFormik.values.genClientID,
        clientContactID: jgFormik.values.JobClientContactID,
        skills: jgFormik.values.genJobskills.join(", "),
        jobType: jgFormik.values.genJobType,
        jobRole: jgFormik.values.genJobRole,
        description: jgFormik.values.genJobdescription,
        location: jgFormik.values.genJobLocation,
        minYearsExperience: Number(jgFormik.values.genMinYearsExperience),
        maxYearsExperience: Number(jgFormik.values.genMaxYearsExperience),
        salary_min: Number(jgFormik.values.genSalaryMin),
        salary_max: Number(jgFormik.values.genSalaryMax),
        priority: Number(jgFormik.values.genJobPriority),
        tags: jgFormik.values.genJobtags,
        openings: Number(jgFormik.values.genNumOp),
        generateDescription: jgFormik.values.generateDescription,
      };
      const payload = filterPayload(rawPayload);
      const assignedTo = (jgFormik.values.genAssignedTo || []).map(String);
      if (assignedTo.length > 0) {
        payload.assigned_to = assignedTo;
      }
      await post(VYLABS_BASE_URL, CREATE_JOB, payload);
      setIsModalOpenJobGeneration(false);
      jgFormik.resetForm();
      jgFormik.setFieldValue("genJobtags", []);
      jgFormik.setFieldValue("genJobskills", []);
      jgFormik.setFieldValue("genAssignedTo", []);
      setClientList([]);
      setMembersList([]);
      setJobGenClient(null);
      Toast("success", "Job generated successfully");
      setHasSearchedJobs(false);
      setIsSearchMode(false);
      setSearchPage(1);
      setJobTablePage(1);
      setOffset(0);
      setCurrentFilter(DEFAULT_JOB_STATUS_FILTER);
      setJobsRefreshKey((prev) => prev + 1);
    } catch (error) {
      setIsCreatingJob(false);
      setIsWebSocketOpen(false);
      setIsInitialLoading(false);
      console.error("API Error Details:", {
        message: error.message,
        config: error.config,
        response: error.response?.data,
      });
      Toast(
        "error",
        `Generation failed: ${error.response?.data?.message || error.message}`,
      );
    } finally {
      setIsCreatingJob(false);
      setIsWebSocketOpen(false);
      setIsGenerating(false);
    }
  };

  const lastElement = useCallback(
    (node) => {
      const hasMoreItems = isSearchMode ? hasMoreSearchResults : hasMore;
      if (!hasMoreItems) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && hasMoreItems && !isLoadingMore) {
            if (isSearchMode) {
              loadMoreSearchResults();
            } else {
              setIsLoadingMore(true);
              setOffset((prev) => prev + 10);
            }
          }
        },
        {
          root: null,
          rootMargin: "20px",
          threshold: 0.1,
        },
      );

      if (node) observer.current.observe(node);
    },
    [hasMore, hasMoreSearchResults, isLoadingMore, isSearchMode],
  );

  useEffect(() => {
    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, []);

  const fetchClientOptions = async (
    inputValue = "",
    { setOptions, setLoading, setNoClients, requestRef },
  ) => {
    const requestId = ++requestRef.current;
    try {
      setLoading(true);
      let response;

      if (inputValue) {
        response = await get(
          VYLABS_BASE_URL,
          `${SEARCH_CLIENTS}?company_name=${encodeURIComponent(inputValue)}`,
        );
      } else {
        response = await get(VYLABS_BASE_URL, `${GET_CLIENTS_LIST}`);
      }

      if (requestId !== requestRef.current) return; // stale response

      const { clients = [] } = response || {};
      const fetchedClients = Array.isArray(clients)
        ? clients
            .filter((c) => c?.id && c?.name)
            .map((c) => ({
              label: c.name,
              value: c.id,
            }))
        : [];

      setNoClients(inputValue === "" && fetchedClients.length === 0);
      setOptions(fetchedClients);
    } catch (err) {
      console.error("fetchClientOptions error", err);
      if (requestId === requestRef.current) setOptions([]);
    } finally {
      if (requestId === requestRef.current) setLoading(false);
    }
  };

  const jobGenClientFetchConfig = {
    setOptions: setClientList,
    setLoading: setJobGenClientLoading,
    setNoClients: setJobGenNoClients,
    requestRef: jobGenClientReqRef,
  };

  const simpleSearchClientFetchConfig = {
    setOptions: setSimpleSearchClientList,
    setLoading: setSimpleSearchClientLoading,
    setNoClients: setSimpleSearchNoClients,
    requestRef: simpleSearchClientReqRef,
  };

  const fetchClientContacts = useCallback(async () => {
    const clientId = jgFormik.values.genClientID;
    const requestId = ++jobGenClientContactsReqRef.current;
    if (!clientId) {
      setClientContacts([]);
      return;
    }

    try {
      const clientContactsRes = await get(
        VYLABS_BASE_URL,
        `${GET_CLIENT_DETAILS}?id=${clientId}`,
      );
      if (requestId !== jobGenClientContactsReqRef.current) return;
      if (clientContactsRes?.client?.contacts) {
        setClientContacts(
          mapClientContactsToOptions(clientContactsRes.client.contacts),
        );
      } else {
        setClientContacts([]);
      }
    } catch (error) {
      console.error("Error fetching client contacts:", error);
      if (requestId === jobGenClientContactsReqRef.current) {
        setClientContacts([]);
      }
    }
  }, [jgFormik.values.genClientID]);

  useEffect(() => {
    fetchClientContacts();
  }, [fetchClientContacts]);

  const fetchSimpleSearchClientContacts = useCallback(async () => {
    const clientId = searchParams.client_id;
    const requestId = ++simpleSearchClientContactsReqRef.current;
    if (!clientId) {
      setSimpleSearchClientContacts([]);
      return;
    }

    try {
      const clientContactsRes = await get(
        VYLABS_BASE_URL,
        `${GET_CLIENT_DETAILS}?id=${clientId}`,
      );
      if (requestId !== simpleSearchClientContactsReqRef.current) return;
      setSimpleSearchClientContacts(
        mapClientContactsToOptions(clientContactsRes?.client?.contacts),
      );
    } catch (error) {
      console.error("Error fetching simple search client contacts:", error);
      if (requestId === simpleSearchClientContactsReqRef.current) {
        setSimpleSearchClientContacts([]);
      }
    }
  }, [searchParams.client_id]);

  useEffect(() => {
    fetchSimpleSearchClientContacts();
  }, [fetchSimpleSearchClientContacts]);

  const handleClientInputChange = (_, value, reason) => {
    if (reason === "reset") return;
    fetchClientOptions(value || "", jobGenClientFetchConfig);
  };

  const handleClientOpen = () => {
    if (clientList.length === 0) {
      fetchClientOptions("", jobGenClientFetchConfig);
    }
  };

  const handleSimpleSearchClientInputChange = (_, value, reason) => {
    if (reason === "reset") return;
    fetchClientOptions(value || "", simpleSearchClientFetchConfig);
  };

  const handleSimpleSearchClientOpen = () => {
    if (simpleSearchClientList.length === 0) {
      fetchClientOptions("", simpleSearchClientFetchConfig);
    }
  };

  const handleEditJob = () => {
    setOriginalJobData({ ...selectedJob });
    setEditedJobData({ ...selectedJob });
    formik.setFieldValue("jobPriority", selectedJob.priority?.toString() || "");

    // Pre-select the recruiters already assigned to this job
    const assignedUsers = Array.isArray(selectedJob?.assigned_to)
      ? selectedJob.assigned_to.filter((u) => u?.id)
      : [];
    formik.setFieldValue(
      "assignedTo",
      assignedUsers.map((u) => String(u.id)),
    );
    setMembersList((prev) => {
      const seeded = assignedUsers.map((u) => ({
        id: u.id,
        label: u.name || "N/A",
        value: String(u.id),
      }));
      const seededIds = new Set(seeded.map((s) => s.value));
      return [
        ...seeded,
        ...prev.filter((m) => !seededIds.has(String(m?.value))),
      ];
    });
    fetchAllMembers("");
    setIsEditingJob(true);
  };
  const resetJobEdit = () => {
    if (originalJobData) {
      setSelectedJob(originalJobData);
      formik.setValues({
        title: originalJobData.title || "",
        minYearsExperience:
          originalJobData.min_years_experience?.toString() || "",
        maxYearsExperience:
          originalJobData.max_years_experience?.toString() || "",
        educationLevel: originalJobData.education_level || "",
        company: originalJobData.company || "",
        jobLocation: originalJobData.location || "",
        jobType: originalJobData.job_type || "",
        skills: Array.isArray(originalJobData.skills)
          ? originalJobData.skills
          : typeof originalJobData.skills === "string"
            ? [originalJobData.skills]
            : [],
        jobDescription: originalJobData.description || "",
        jobRole: originalJobData.job_role || "",
        salary_min: originalJobData.salary_min?.toString() || "",
        salary_max: originalJobData.salary_max?.toString() || "",
        jobPriority: originalJobData.priority?.toString() || "",
        tags: originalJobData.tags || [],
        clientID: originalJobData.clientID || "",
        languageProficiency: originalJobData.language_proficiency || "",
        openings: originalJobData.openings?.toString() || "",
        assignedTo: (originalJobData.assigned_to || []).map((u) =>
          String(u.id),
        ),
      });
    }
    setIsEditingJob(false);
    setOriginalJobData(null);
    setEditedJobData(null);
  };
  const handleOpenDeleteJobDiolog = () => {
    setOpenJobDeleteDialog(true);
  };

  const handleDeleteJob = async () => {
    try {
      await deleteRequest(
        VYLABS_BASE_URL,
        `${DELETE_JOB_DETAILS}?id=${selectedJob.id}`,
      );
      Toast("success", "Job deleted successfully");
      setJobList((prevJobs) =>
        prevJobs.filter((job) => job.id !== selectedJob.id),
      );
      handleCloseJobsSideContainer();
      fetchJobs(0);
    } catch (error) {
      console.error("Error deleting job:", error);
    } finally {
      setOpenJobDeleteDialog(false);
    }
  };

  const handleJobStatusToggle = (newActiveStatus, jobId) => {
    setAllJobs((prevJobs) =>
      prevJobs.map((job) =>
        job.id === jobId ? { ...job, active: newActiveStatus } : job,
      ),
    );

    if (currentFilter === "all") {
      setJobList((prevJobs) =>
        prevJobs.map((job) =>
          job.id === jobId ? { ...job, active: newActiveStatus } : job,
        ),
      );
    } else if (currentFilter === "active") {
      if (!newActiveStatus) {
        setJobList((prevJobs) => prevJobs.filter((job) => job.id !== jobId));
      }
    } else if (currentFilter === "inactive") {
      if (newActiveStatus) {
        setJobList((prevJobs) => prevJobs.filter((job) => job.id !== jobId));
      }
    }

    if (selectedJob && selectedJob.id === jobId) {
      setSelectedJob((prev) => ({ ...prev, active: newActiveStatus }));
    }
  };
  const handleJobChange = (data) => {
    if (data.validateForm) {
      setJobDetailsValidation(() => data.validateForm);
    } else {
      const updatedValues = {
        ...formik.values,
        title: data.title || formik.values.title,
        jobRole: data.job_role || formik.values.jobRole,
        jobDescription: data.description || formik.values.jobDescription,
        skills: data.skills || formik.values.skills,
        tags: data.tags || formik.values.tags,
        clientID: data.clientID || formik.values.clientID,
        openings: data.openings || formik.values.openings,
      };
      formik.setValues(updatedValues);
      setEditedJobData((prev) => ({
        ...prev,
        ...data,
        min_years_experience: formik.values.minYearsExperience,
        max_years_experience: formik.values.maxYearsExperience,
        location: formik.values.jobLocation,
        salary_min: formik.values.salary_min,
        salary_max: formik.values.salary_max,
        job_type: formik.values.jobType,
        openings: formik.values.openings,
      }));
    }
  };

  const saveJobChanges = async () => {
    const jobDetailsResult = jobDetailsValidation
      ? await jobDetailsValidation()
      : { isValid: true, values: {} };

    const parentErrors = await formik.validateForm();
    const isParentValid = Object.keys(parentErrors).length === 0;

    if (!jobDetailsResult.isValid || !isParentValid) {
      formik.setTouched({
        title: true,
        jobRole: true,
        jobType: true,
        jobLocation: true,
        minYearsExperience: true,
        maxYearsExperience: true,
        salary_min: true,
        salary_max: true,
        // jobDescription: true,
        skills: true,
        // tags: true,
        openings: true,
      });
      Toast("error", "Please fill all required fields correctly");
      return;
    }
    const mainFormValues = formik.values;
    const combinedValues = {
      ...mainFormValues,
      title: mainFormValues.title || jobDetailsResult.values.title,
      jobRole: mainFormValues.jobRole || jobDetailsResult.values.job_role,
      jobDescription:
        jobDetailsResult.values.description ||
        mainFormValues.jobDescription ||
        "",
      skills: mainFormValues.skills || jobDetailsResult.values.skills,
      tags: mainFormValues.tags || jobDetailsResult.values.tags,
      openings: mainFormValues.openings || jobDetailsResult.values.openings,
      jobPriority: mainFormValues.jobPriority,
      assignedTo: mainFormValues.assignedTo || [],
    };
    const originalValues = {
      title: selectedJob.title,
      jobRole: selectedJob.job_role,
      jobType: selectedJob.job_type,
      jobMinYearsExperience: selectedJob.min_years_experience,
      jobMaxYearsExperience: selectedJob.max_years_experience,
      salary_min: selectedJob.salary_min,
      salary_max: selectedJob.salary_max,
      jobLocation: selectedJob.location,
      jobDescription: selectedJob.description,
      skills: selectedJob.skills,
      tags: selectedJob.tags,
      openings: selectedJob.openings,
      priority: selectedJob.priority,
      assignedTo: (selectedJob.assigned_to || []).map((u) => String(u.id)),
    };
    const normalizeSkillsTags = (value) =>
      Array.isArray(value) ? value.join(", ") : value || "";
    const normalizeNumber = (value) => {
      if (value === undefined || value === null || value === "") return 0;
      return Number(value);
    };
    const changedFields = {};
    if (combinedValues.title !== originalValues.title)
      changedFields.title = combinedValues.title;
    if (combinedValues.jobRole !== originalValues.jobRole)
      changedFields.jobRole = combinedValues.jobRole;
    if (combinedValues.jobType !== originalValues.jobType)
      changedFields.jobType = combinedValues.jobType;
    if (
      normalizeNumber(combinedValues.minYearsExperience) !==
      normalizeNumber(originalValues.jobMinYearsExperience)
    ) {
      changedFields.minYearsExperience = combinedValues.minYearsExperience;
    }
    if (
      normalizeNumber(combinedValues.maxYearsExperience) !==
      normalizeNumber(originalValues.jobMaxYearsExperience)
    ) {
      changedFields.maxYearsExperience = combinedValues.maxYearsExperience;
    }
    if (
      normalizeNumber(combinedValues.salary_min) !==
      normalizeNumber(originalValues.salary_min)
    ) {
      changedFields.salary_min = combinedValues.salary_min;
    }
    if (
      normalizeNumber(combinedValues.salary_max) !==
      normalizeNumber(originalValues.salary_max)
    ) {
      changedFields.salary_max = combinedValues.salary_max;
    }
    if (combinedValues.jobLocation !== originalValues.jobLocation)
      changedFields.jobLocation = combinedValues.jobLocation;
    if (combinedValues.jobDescription !== originalValues.jobDescription)
      changedFields.jobDescription = combinedValues.jobDescription;
    if (
      normalizeSkillsTags(combinedValues.skills) !==
      normalizeSkillsTags(originalValues.skills)
    ) {
      changedFields.skills = combinedValues.skills;
    }
    if (
      normalizeSkillsTags(combinedValues.tags) !==
      normalizeSkillsTags(originalValues.tags)
    ) {
      changedFields.tags = combinedValues.tags;
    }
    if (
      normalizeNumber(combinedValues.openings) !==
      normalizeNumber(originalValues.openings)
    ) {
      changedFields.openings = combinedValues.openings;
    }
    if (
      normalizeNumber(combinedValues.jobPriority) !==
      normalizeNumber(originalValues.priority)
    ) {
      changedFields.jobPriority = combinedValues.jobPriority;
    }
    const sameIdSet = (a = [], b = []) => {
      const setA = new Set(a.map(String));
      const setB = new Set(b.map(String));
      return setA.size === setB.size && [...setA].every((id) => setB.has(id));
    };
    if (!sameIdSet(combinedValues.assignedTo, originalValues.assignedTo)) {
      changedFields.assigned_to = (combinedValues.assignedTo || []).map(String);
    }
    if (Object.keys(changedFields).length === 0) {
      Toast("info", "No changes detected");
      setIsEditingJob(false);
      handleCloseJobsSideContainer();
      return;
    }
    try {
      const jobData = {
        jobID: selectedJob.id,
      };
      if (changedFields.hasOwnProperty("title"))
        jobData.jobTitle = changedFields.title;
      if (changedFields.hasOwnProperty("jobRole"))
        jobData.jobRole = changedFields.jobRole;
      if (changedFields.hasOwnProperty("jobType"))
        jobData.jobType = changedFields.jobType;
      if (changedFields.hasOwnProperty("minYearsExperience"))
        jobData.jobMinYearsExperience = Number(
          changedFields.minYearsExperience || 0,
        );
      if (changedFields.hasOwnProperty("maxYearsExperience"))
        jobData.jobMaxYearsExperience = Number(
          changedFields.maxYearsExperience || 0,
        );
      if (changedFields.hasOwnProperty("salary_min"))
        jobData.salary_min = Number(changedFields.salary_min || 0);
      if (changedFields.hasOwnProperty("salary_max"))
        jobData.salary_max = Number(changedFields.salary_max || 0);
      if (changedFields.hasOwnProperty("jobLocation"))
        jobData.jobLocation = changedFields.jobLocation;
      if (changedFields.hasOwnProperty("jobDescription"))
        jobData.jobDescription = changedFields.jobDescription;
      if (changedFields.hasOwnProperty("skills")) {
        jobData.jobSkills = Array.isArray(changedFields.skills)
          ? changedFields.skills.join(", ")
          : changedFields.skills || "";
      }
      if (changedFields.hasOwnProperty("tags")) {
        jobData.jobTags = Array.isArray(changedFields.tags)
          ? changedFields.tags.join(", ")
          : changedFields.tags || "";
      }
      if (changedFields.hasOwnProperty("openings"))
        jobData.jobOpenings = Number(changedFields.openings || 0);
      if (changedFields.hasOwnProperty("jobPriority"))
        jobData.jobPriority = Number(changedFields.jobPriority || 0);
      if (changedFields.hasOwnProperty("assigned_to"))
        jobData.assigned_to = changedFields.assigned_to;
      await put(VYLABS_BASE_URL, UPDATE_JOB, jobData);
      const updatedJob = {
        ...selectedJob,
        id: selectedJob.id,
        ...(changedFields.title && { title: changedFields.title }),
        ...(changedFields.jobRole && { job_role: changedFields.jobRole }),
        ...(changedFields.jobType && { job_type: changedFields.jobType }),
        ...(changedFields.minYearsExperience && {
          min_years_experience: changedFields.minYearsExperience,
        }),
        ...(changedFields.maxYearsExperience && {
          max_years_experience: changedFields.maxYearsExperience,
        }),
        ...(changedFields.salary_min && {
          salary_min: changedFields.salary_min,
        }),
        ...(changedFields.salary_max && {
          salary_max: changedFields.salary_max,
        }),
        ...(changedFields.jobLocation && {
          location: changedFields.jobLocation,
        }),
        ...(changedFields.jobDescription && {
          description: changedFields.jobDescription,
        }),
        ...(changedFields.skills && { skills: changedFields.skills }),
        ...(changedFields.tags && { tags: changedFields.tags }),
        ...(changedFields.openings && { openings: changedFields.openings }),
        ...(changedFields.jobPriority && {
          priority: Number(changedFields.jobPriority),
        }),
        ...(changedFields.assigned_to && {
          assigned_to: changedFields.assigned_to.map((id) => {
            const member = membersList.find((m) => String(m?.value) === id);
            const prev = (selectedJob.assigned_to || []).find(
              (u) => String(u.id) === id,
            );
            return { id, name: member?.label || prev?.name || "" };
          }),
        }),
      };
      setSelectedJob(updatedJob);
      setIsEditingJob(false);
      Toast("success", "Job updated successfully");
      setJobList((prevJobs) =>
        prevJobs.map((job) => (job.id === updatedJob.id ? updatedJob : job)),
      );
      handleCloseJobsSideContainer();
      setTimeout(() => {
        fetchJobs(0);
      }, 1000);
    } catch (error) {
      console.error("Error updating job:", error);
      Toast(
        "error",
        "Failed to update job: " +
          (error.response?.data?.message || error.message),
      );
    }
  };
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const renderBotResponse = (message) => {
    if (message.sender !== "bot") return null;
    const jobs = (message.jobs || []).map((job, index) => ({
      ...job,
      icon: jobIcons[index % jobIcons.length],
    }));

    const { summary } = parseMessageText(message.text);

    return (
      <div className="bot-message-container">
        <img src={BotReplyIcon} alt="BotReplyIcon" className="replay-icon" />
        <div
          className="bot-message-content"
          style={
            message.isLoading
              ? { border: "none" }
              : {
                  border: "1px solid var(--border__color)",
                  padding: "15px",
                  borderRadius: "8px",
                }
          }
        >
          {message.isLoading ? (
            <ThinkingBubble />
          ) : (
            <div className="text-with-card-container">
              <div className="summary-container">
                {summary &&
                  summary.split("\n").map((line, idx) => {
                    const trimmedLine = line.trim();
                    const bulletContent = getBulletContent(trimmedLine);
                    if (bulletContent !== null) {
                      return (
                        <div
                          key={idx}
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            marginBottom: "5px",
                          }}
                        >
                          <img
                            src={BotResponseStarIcon}
                            alt="bullet"
                            style={{
                              width: "18px",
                              height: "18px",
                              marginRight: "8px",
                              marginTop: "10px",
                              flexShrink: 0,
                            }}
                          />
                          <span
                            style={{
                              fontSize: "18px",
                              textAlign: "left",
                              color: "var(--chat-text)",
                              whiteSpace: "pre-wrap",
                            }}
                          >
                            {renderInlineMarkdown(bulletContent)}
                          </span>
                        </div>
                      );
                    }
                    return (
                      <p
                        key={idx}
                        style={{
                          fontSize: "18px",
                          textAlign: "left",
                          color: "var(--chat-text)",
                          whiteSpace: "pre-wrap",
                          marginBottom: "5px",
                          marginTop: "0px",
                          minHeight: line.trim() ? "auto" : "1em",
                        }}
                      >
                        {renderBotContent(line)}
                      </p>
                    );
                  })}
                {message.isStreaming && (
                  <>
                    <style>{`@keyframes vyblink{0%,100%{opacity:1}50%{opacity:0}}`}</style>
                    <span
                      style={{
                        display: "inline-block",
                        width: "7px",
                        height: "16px",
                        marginLeft: "2px",
                        background: "var(--chat-text)",
                        animation: "vyblink 1s steps(1) infinite",
                        verticalAlign: "text-bottom",
                      }}
                    />
                  </>
                )}
              </div>
              <div className="jobs-grid">
                {jobs.map((job, index) => (
                  <JobsCard
                    key={job.id}
                    jobId={job.id}
                    title={job.title}
                    subTitle={job.subTitle}
                    role={job.subTitle}
                    priority={getPriorityLabel(job.priority)}
                    minYearsExperience={job.min_years_experience}
                    maxYearsExperience={job.max_years_experience}
                    experience={job.years_experience}
                    jobtype={job.job_type}
                    client={applyEllipsis(job?.client?.name, 15)}
                    jobRole={job?.job_role}
                    actionText={true}
                    viewJob={job.viewJob}
                    skills={job.skills}
                    minSalary={job.salary_min}
                    maxSalary={job.salary_max}
                    tags={job.tags}
                    location={job.location}
                    client_contact_person={applyEllipsis(
                      job?.client_contact
                        ? job?.client_contact?.name
                        : job?.client?.contact_person,
                      10,
                    )}
                    cardbackgroundColor="linear-gradient( rgb(66 185 120 / 31%), #D6FFE8)"
                    cardColor="rgb(8 104 29)"
                    skillbackgroundColor="rgb(12 122 51 / 74%)"
                    skillColor="#fff"
                    icon={job.icon}
                    isActive={job.active}
                    onStatusToggle={handleJobStatusToggle}
                    viewJobEventHandler={(e) => {
                      e.stopPropagation();
                      handleOpenJobsSideContainer(job, index, "Job Details");
                    }}
                    assignCandidateEventHandler={(e) => {
                      e.stopPropagation();
                      handleOpenJobsSideContainer(
                        job,
                        index,
                        "Assigned Candidates",
                      );
                    }}
                    editJobEventHandler={(e) => {
                      e.stopPropagation();
                      setActiveTab("Job Details");
                      handleOpenJobsSideContainer(job, index, "Job Details");
                      setIsEditingJob(true);
                    }}
                    matchPercentage={
                      hasSearchedJobs || isSearchMode
                        ? job.match_percentage
                        : undefined
                    }
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderChatMessages = () => {
    return (
      <div className="chat-messages-container">
        {messages.map((message, index) => (
          <div key={index} className={`message-wrapper ${message.sender}`}>
            {message.sender === "user" ? (
              <div className="user-message-container">
                <div className="user-message-content">
                  <p className="job-user-message-query-text">{message.text}</p>
                </div>
              </div>
            ) : (
              renderBotResponse(message)
            )}
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>
    );
  };

  useEffect(() => {
    if (selectedJob && !isEditingJob) {
      const initialValues = {
        title: selectedJob.title || "",
        minYearsExperience: selectedJob.min_years_experience?.toString() || "",
        maxYearsExperience: selectedJob.max_years_experience?.toString() || "",
        company: selectedJob.company || "",
        jobLocation: selectedJob.location || "",
        jobType: selectedJob.job_type || "",
        skills: Array.isArray(selectedJob.skills)
          ? selectedJob.skills
          : typeof selectedJob.skills === "string"
            ? [selectedJob.skills]
            : [],
        jobDescription: selectedJob.description || "",
        jobRole: selectedJob.job_role || "",
        salary_min: selectedJob.salary_min?.toString() || "",
        salary_max: selectedJob.salary_max?.toString() || "",
        tags: selectedJob.tags || [],
        languageProficiency: selectedJob.language_proficiency || "",
        openings: selectedJob.openings?.toString() || "",
        jobPriority: selectedJob.priority?.toString() || "",
        assignedTo: (selectedJob.assigned_to || []).map((u) => String(u.id)),
      };
      formik.setValues(initialValues);
    }
  }, [selectedJob, isEditingJob]);

  const getActiveJobs = () => allJobs.filter((job) => job.active === true);
  const getInactiveJobs = () => allJobs.filter((job) => !("active" in job));

  const hasActiveJobs = getActiveJobs().length > 0;
  const hasInactiveJobs = getInactiveJobs().length > 0;
  const hasJobPostings = allJobs.length > 0;
  const hasJobsForStatusTabs = hasActiveJobs || hasInactiveJobs;
  const isStatusFilterApplied = Boolean(
    JOB_STATUS_FILTER_LABELS[currentFilter],
  );
  const searchTotalCount = searchTotalJobs || jobsList.length;
  const searchShowingCount =
    trackedViewTab === 1
      ? Math.min(jobTablePage * 10, searchTotalCount)
      : Math.min(jobsList.length, searchTotalCount);
  const shouldShowJobFilters =
    hasActiveJobs ||
    hasInactiveJobs ||
    isInitialLoading ||
    isLoadingMore ||
    hasSearchedJobs ||
    isSearchMode ||
    isStatusFilterApplied ||
    Boolean(createdByUserId);
  const canDeleteJob = AdminAccess;
  const canSwitchJobView = AdminAccess || MemberAccess;
  const canShowJobFilterControl = !MemberAccess;
  const canShowJobStatusTabs = AdminAccess || MemberAccess;

  useEffect(() => {
    if (!canShowJobFilterControl && isJobFilterOpen) {
      setIsJobFilterOpen(false);
    }
  }, [canShowJobFilterControl, isJobFilterOpen]);

  const jobColumnsDefinition = useMemo(
    () => [
      {
        name: "Job Role",
        selector: (row) => row.job_role || "N/A",
      },
      {
        name: isHiringTeamTenant ? "Hiring Team" : "Client",
        selector: (row) => row.client?.name || "N/A",
        cell: (row) => (
          <CustomTooltip title={row.client?.name || "N/A"} arrow>
            <span>{row.client?.name || "N/A"}</span>
          </CustomTooltip>
        ),
      },
      {
        name: "Priority",
        selector: (row) => getPriorityLabel(row.priority),
        cell: (row) => {
          const priorityData = getPriorityData(row.priority);

          return (
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                color: priorityData?.color || "#6B7280",
                fontWeight: 600,
              }}
            >
              {priorityData?.icon && (
                <img
                  src={priorityData.icon}
                  alt={priorityData.name}
                  style={{ width: "16px", height: "16px" }}
                />
              )}
              {priorityData?.name || "N/A"}
            </span>
          );
        },
      },
      {
        name: "Openings",
        selector: (row) =>
          typeof row.openings === "number" ? row.openings : "N/A",
      },
      {
        name: "Job Type",
        selector: (row) => row.job_type || "N/A",
      },
      {
        name: "Location",
        selector: (row) => row.location || "N/A",
      },
      {
        name: "Created at",
        selector: (row) => formatDateWithUserTimezone(row.created_at) || "N/A",
        cell: (row) => (
          <CustomTooltip
            title={formatDateWithUserTimezone(row.created_at) || "N/A"}
            arrow
          >
            <span>{formatDateWithUserTimezone(row.created_at) || "N/A"}</span>
          </CustomTooltip>
        ),
      },
      {
        name: "Updated at",
        selector: (row) => formatDateWithUserTimezone(row.updated_at) || "N/A",
        cell: (row) => (
          <CustomTooltip
            title={formatDateWithUserTimezone(row.updated_at) || "N/A"}
            arrow
          >
            <span>{formatDateWithUserTimezone(row.updated_at) || "N/A"}</span>
          </CustomTooltip>
        ),
      },
      {
        name: "Action",
        cell: (row) => (
          <HandleViewCell row={row} onView={handleOpenJobsSideContainer} />
        ),
        width: "90px",
        center: true,
        ignoreRowClick: true,
        allowOverflow: true,
      },
    ],
    [handleOpenJobsSideContainer],
  );

  const searchJobColumnsDefinition = useMemo(
    () => [
      ...jobColumnsDefinition,
      {
        name: "Match Fit",
        selector: (row) =>
          getJobMatchFitLabel(row.match_percentage ?? row.matchPercentage),
        width: "150px",
        minWidth: "140px",
        maxWidth: "170px",
        cell: (row) => {
          const fitLabel = getJobMatchFitLabel(
            row.match_percentage ?? row.matchPercentage,
          );
          return (
            <span className={getJobMatchFitClassName(fitLabel)}>
              {fitLabel}
            </span>
          );
        },
      },
    ],
    [jobColumnsDefinition],
  );

  const handleJobTablePageChange = (page) => {
    setJobTablePage(page);

    if (isSearchMode || hasSearchedJobs) {
      if (page === searchPage || isLoadingMore || isInitialLoading) return;
      handleJobSimpleSearch(page, false, null, 10);
      return;
    }

    if (!hasMore || isLoadingMore) return;

    const itemsPerPage = 10;
    const newOffset = (page - 1) * itemsPerPage;
    const totalPagesInState = Math.ceil(jobsList.length / itemsPerPage);
    const hasDataForPage = jobsList.length >= page * itemsPerPage;
    if (!hasDataForPage) {
      setOffset(newOffset);
    }
    if (
      page === totalPagesInState &&
      jobsList.length % itemsPerPage === 0 &&
      jobsList.length > 0
    ) {
      setOffset(jobsList.length);
    }
  };

  const handleToggleSelectMode = () => {
    setIsSelectMode((prev) => !prev);
    if (isSelectMode) {
      setSelectedJobs([]);
    }
  };

  const handleJobSelect = (job, event) => {
    event && event.stopPropagation();
    if (selectedJobs.some((j) => j.id === job.id)) {
      setSelectedJobs(selectedJobs.filter((j) => j.id !== job.id));
    } else {
      setSelectedJobs([...selectedJobs, job]);
    }
  };

  const selectAllJobs = () => {
    if (selectedJobs.length === jobsList.length) {
      setSelectedJobs([]);
    } else {
      setSelectedJobs([...jobsList]);
    }
  };

  const handleVendorEmail = () => {
    if (isMonthlyEmailLimitReached) {
      Toast("error", "Monthly email limit reached. Please upgrade your plan.");
      return;
    }

    if (selectedJobs.length === 0) {
      Toast("error", "Please select at least one job to send vendor email.");
      return;
    }
    setIsVendorSelectionOpen(true);
  };

  const handleVendorSelect = (vendor) => {
    setIsVendorSelectionOpen(false);
    setIsSelectMode(false);
    setSelectedJobs([]);
  };

  const showFitCalculationButton =
    hasSearchedJobs && jobsList.length > 0 && !isSelectMode;

  const renderJobSearchBox = (clientKeyPrefix = "autocomplete-client") => (
    <JobSimpleSearchBox
      key={`${clientKeyPrefix}-${trackedViewTab}`}
      queryValue={searchParams.query}
      onQueryChange={(e) =>
        setSearchParams({
          ...searchParams,
          query: e.target.value,
        })
      }
      jobRoleValue={searchParams.job_role}
      onJobRoleChange={(e) =>
        setSearchParams({
          ...searchParams,
          job_role: e.target.value,
        })
      }
      jobTypeValue={searchParams.job_type}
      onJobTypeChange={(e) =>
        setSearchParams({
          ...searchParams,
          job_type: e.target.value,
        })
      }
      locationValue={searchParams.location}
      onLocationChange={(e) =>
        setSearchParams({
          ...searchParams,
          location: e.target.value,
        })
      }
      skillsValue={searchParams.skills.join(", ")}
      onSkillsChange={(e) =>
        setSearchParams({
          ...searchParams,
          skills: e.target.value.split(",").map((s) => s.trim()),
        })
      }
      priorityValue={searchParams.priority}
      onPriorityChange={(e) =>
        setSearchParams({
          ...searchParams,
          priority: e.target.value,
        })
      }
      minYearsExperienceValue={searchParams.min_years_experience}
      onMinYearsExperienceChange={(e) =>
        setSearchParams({
          ...searchParams,
          min_years_experience: e.target.value,
        })
      }
      maxYearsExperienceValue={searchParams.max_years_experience}
      onMaxYearsExperienceChange={(e) =>
        setSearchParams({
          ...searchParams,
          max_years_experience: e.target.value,
        })
      }
      clientValue={
        searchParams.client_id
          ? simpleSearchClient?.value === searchParams.client_id
            ? simpleSearchClient
            : simpleSearchClientList.find(
                (client) => client.value === searchParams.client_id,
              ) || null
          : null
      }
      onClientValueChange={(selectedClient) => {
        setSimpleSearchClient(selectedClient || null);
        setSimpleSearchClientContacts([]);
        setSearchParams((prev) => ({
          ...prev,
          client_id: selectedClient?.value || "",
          client_contact_id: "",
        }));
      }}
      clientContactValue={searchParams.client_contact_id}
      onClientContactChange={(e) =>
        setSearchParams({
          ...searchParams,
          client_contact_id: e.target.value,
        })
      }
      clientOnInputChange={handleSimpleSearchClientInputChange}
      clientOnOpen={handleSimpleSearchClientOpen}
      clientNoOptionsText={
        simpleSearchNoClients ? "No clients..." : "No options..."
      }
      clientOptions={simpleSearchClientList}
      clientLoading={simpleSearchClientLoading}
      clientContactOptions={simpleSearchClientContacts}
      userJobRelationValue={searchParams.user_job_relation}
      onUserJobRelationChange={(e) =>
        setSearchParams({
          ...searchParams,
          user_job_relation: e.target.value,
        })
      }
      currentUserId={userDetails?.id || ""}
      onClearForm={handleClearSearchForm}
      hasSearched={hasSearchedJobs}
      onSubmit={(submittedSearchParams) => {
        setJobTablePage(1);
        handleSimpleSearchSubmit(submittedSearchParams);
      }}
      isSimpleSearchLoading={isInitialLoading}
      recommendedSearchBoxTitle="Job Search"
      subText="Find the perfect job opportunity"
      advancedFiltersInSidePopup
      userAssignedTo={assignedDetails}
    />
  );

  return (
    <div>
      <div className="header-main-container">
        <div className="header-icon-title-container">
          <img
            alt=""
            src={isDarkMode ? JobsDarkIcon : jobsPageIcon}
            className="header-title-icon"
          ></img>
          <h2 className="header-container">Jobs</h2>
        </div>
        <div className="jobs-header-button-container">
          {showBackToList && (
            <div className="back-to-job-list-button">
              <Button
                label="Back to Jobs List"
                iconSrc={rightArrowIcon}
                iconPosition="left"
                iconStyle={{ marginRight: "8px" }}
                event={handleBackToList}
                className={`can-btn ${"active"}`}
              />
            </div>
          )}
          <div className="selection-actions">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                flex: 1,
              }}
            >
              {showFitCalculationButton && (
                <Button
                  label="How is fit calculated?"
                  event={() => setShowMatchPercentagePopup(true)}
                  iconSrc={networkIcon}
                  iconWidth="18px"
                />
              )}
            </div>
            <div className="select-button-container">
              {/* { !isImportOpen ? (
                <Button
                label="Import Job"
                iconSrc={VybogTALJobGenIcon}
                iconWidth="15px"
                color="var(--header__color)"
                backgroundColor="var(--body__background)"
                border="1px solid var(--border__color)"
                event={() => setIsImportOpen(true)}
                style={{ padding: "6px 14px" }}
              />
              ) : isImportOpen && (
                <div style={{display: "flex", gap: "5px"}}>
                <Button
                  label="Back to Jobs List"
                  iconSrc={rightArrowIcon}
                  iconWidth="15px"
                  color="var(--header__color)"
                  backgroundColor="var(--body__background)"
                  border="1px solid var(--border__color)"
                  event={() => {
                    setIsImportOpen(false);
                    handleBackToList();
                  }}
                  style={{ padding: "6px 14px" }}
                />
                <Button
                label="Assign Client"
                event={() => setIsAssignClientOpen(true)}
                />
                    <div style={{ display: "flex" }}>
                      <Button
                        label="Import JD"
                        event={() => setJdOrXLImport("JD")}
                        iconSrc={ImportJDIcon}
                        iconWidth="15px"
                        color={JdOrXLImport==="XL" && "var(--header__color)"}
                        backgroundColor={JdOrXLImport==="XL" && "var(--body__background)"}
                        border={JdOrXLImport==="XL" && "1px solid var(--border__color)"}
                        style={{ borderRadius: "10px 0 0 10px" }}
                      />
                      <Button
                        label="Bulk Import"
                        event={() => setJdOrXLImport("XL")}
                        iconSrc={importIcon}
                        iconWidth="15px"
                        color={JdOrXLImport==="JD" && "var(--header__color)"}
                        backgroundColor={JdOrXLImport==="JD" && "var(--body__background)"}
                        border={JdOrXLImport==="JD" && "1px solid var(--border__color)"}
                        style={{ borderRadius: "0 10px 10px 0" }}
                      />
                    </div>
                </div>
              )} */}
              {!MemberAccess && !isImportOpen && (
                <Button
                  label="VybogTAL Job Gen"
                  iconSrc={VybogTALJobGenIcon}
                  iconWidth="15px"
                  backgroundColor="var(--primary__color)"
                  color="#ffffff"
                  event={handleOpenIJobGeneration}
                  className="super-shine-button"
                  style={{ padding: "6px 14px" }}
                />
              )}
              {isVendorFeatureEnabled &&
                !isSelectMode &&
                trackedViewTab === 0 && 
                !isImportOpen && (
                  <Button
                    label="Select"
                    event={handleToggleSelectMode}
                    style={{ padding: "5px 10px" }}
                    backgroundColor="#6665ea"
                    color="#fff"
                    border="1px solid #6665ea"
                  />
                )}
              {isSelectMode && trackedViewTab === 0 && (
                <>
                  <CustomTooltip
                    title={getMonthlyEmailTooltip(
                      "Select jobs to send an email to the vendor.",
                    )}
                    arrow
                  >
                    <span>
                      <Button
                        label={
                          selectedJobs.length > 0
                            ? `Email Vendor (${selectedJobs.length})`
                            : "Email Vendor"
                        }
                        style={{
                          padding: "5px 10px",
                          whiteSpace: "nowrap",
                          opacity: isMonthlyEmailLimitReached ? 0.6 : 1,
                        }}
                        backgroundColor="#6665ea"
                        color="#fff"
                        border="1px solid #6665ea"
                        disabled={isMonthlyEmailLimitReached}
                        event={handleVendorEmail}
                      />
                    </span>
                  </CustomTooltip>
                  <Button
                    label={
                      selectedJobs.length === jobsList.length
                        ? "Deselect All"
                        : "Select All"
                    }
                    event={selectAllJobs}
                    style={{
                      padding: "5px 10px",
                      whiteSpace: "nowrap",
                    }}
                    backgroundColor="#6665ea"
                    color="#fff"
                    border="1px solid #6665ea"
                  />
                  <Button
                    label="Cancel"
                    event={handleToggleSelectMode}
                    style={{ padding: "5px 10px" }}
                    backgroundColor="var(--body__background)"
                    color="var(--header__color)"
                    border="1px solid var(--border__color)"
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <JobStatusUpdatePopup />

      {isImportOpen ? (
        <JobFileUpload JdOrXLImport={JdOrXLImport} defaultClientId={defaultClientIdFormik.values.defaultClientId} />
      ) : (
        <div
          className={`jobs-table-list-container ${
            !hasSearched && trackedViewTab === 1
              ? "jobs-table-mode-container"
              : ""
          }`}
        >
          <div className="jobs-main-container">
            {!hasSearched && hasJobPostings && (
              <div
                className={`job-page-selector-container-wrapper ${
                  trackedViewTab === 1 ? "jobs-table-mode-sticky" : ""
                }`}
              >
                {trackedViewTab === 0 && (
                  <div
                    className="page-selector-container"
                    style={{
                      marginBottom: "20px",
                    }}
                  >
                    {renderJobSearchBox()}
                  </div>
                )}
                {trackedViewTab === 1 && (
                  <div className="page-selector-container jobs-table-search-container">
                    {renderJobSearchBox("table-autocomplete-client")}
                  </div>
                )}
                {shouldShowJobFilters && (
                  <div
                    className="jobs-status-and-view-switcher"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: trackedViewTab === 1 ? "" : "-15px",
                      padding: "4px",
                    }}
                  >
                    <div className="jobs-list-buttons">
                      {canShowJobStatusTabs &&
                        !hasSearchedJobs &&
                        trackedViewTab === 0 &&
                        hasJobsForStatusTabs && (
                          <div
                            className="filter-stages"
                            style={{
                              display: "flex",
                              gap: "8px",
                              marginLeft: "12px",
                            }}
                          >
                            <div
                              className={`grid-btn ${
                                currentFilter === "active" ? "active" : ""
                              }`}
                              onClick={(e) => {
                                e.stopPropagation();
                                applyJobFilters(DEFAULT_JOB_STATUS_FILTER, "");
                              }}
                            >
                              <img src={activeBulb} alt="active-bulb" />
                              <div style={{ fontSize: "14px" }}>
                                Active Jobs
                              </div>
                            </div>
                            <div
                              className={`grid-btn ${
                                currentFilter === "inactive" ? "active" : ""
                              }`}
                              onClick={(e) => {
                                e.stopPropagation();
                                applyJobFilters(
                                  currentFilter === "inactive"
                                    ? "all"
                                    : "inactive",
                                  "",
                                );
                              }}
                            >
                              <img src={inactiveBulb} alt="inactive-bulb" />
                              <div
                                style={{
                                  fontSize: "14px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Inactive Jobs
                              </div>
                            </div>
                          </div>
                        )}
                      {AdminAccess &&
                        !hasSearchedJobs &&
                        trackedViewTab === 1 && (
                          <h3
                            style={{
                              margin: 0,
                              fontSize: "18px",
                              fontWeight: "700",
                              color: "var(--page_Header_Color)",
                              whiteSpace: "nowrap",
                              marginLeft: "12px",
                            }}
                          >
                            All Jobs
                          </h3>
                        )}
                      {!canShowJobStatusTabs && !hasSearchedJobs && (
                        <h3
                          style={{
                            margin: 0,
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "var(--page_Header_Color)",
                            whiteSpace: "nowrap",
                            marginLeft: "12px",
                          }}
                        >
                          All Jobs
                        </h3>
                      )}
                    </div>
                    {!hasSearchedJobs ? (
                      <div className="jobs-right-controls">
                        {canSwitchJobView && currentFilter !== "inactive" && (
                          <div
                            className="filter-stages"
                            style={{ display: "flex" }}
                          >
                            <Button
                              label="Grid"
                              iconSrc={
                                isDarkMode
                                  ? trackedViewTab === 0
                                    ? gridActiveDarkIcon
                                    : gridNotActiveDarkIcon
                                  : trackedViewTab === 0
                                    ? gridSelectIcon
                                    : gridNoSelectIcon
                              }
                              iconPosition="left"
                              iconStyle={{ marginRight: "8px" }}
                              event={handleViewJobGrid}
                              className={`grid-btn ${
                                trackedViewTab === 0 ? "active" : ""
                              }`}
                            />
                            <Button
                              label="Table"
                              iconSrc={
                                isDarkMode
                                  ? trackedViewTab === 1
                                    ? tableActiveDarkIcon
                                    : tableNotActiveDarkIcon
                                  : trackedViewTab === 1
                                    ? tableSelectIcon
                                    : tableNoSelectIcon
                              }
                              iconPosition="left"
                              iconStyle={{ marginRight: "8px" }}
                              event={handleViewJobTable}
                              className={`grid-btn ${
                                trackedViewTab === 1 ? "active" : ""
                              }`}
                            />
                          </div>
                        )}
                      </div>
                    ) : (
                      !isInitialLoading && (
                        <>
                          {hasSearchedJobs && jobsList.length > 0 && (
                            <Button
                              label="Back to Jobs List"
                              iconSrc={rightArrowIcon}
                              iconPosition="left"
                              iconStyle={{ marginRight: "8px" }}
                              event={handleBackToList}
                              className={`can-btn ${"active"}`}
                            />
                          )}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              flexWrap: "wrap",
                              justifyContent: "flex-end",
                              flex: 1,
                              marginLeft: "20px",
                            }}
                          >
                            <h3
                              style={{
                                margin: 0,
                                fontSize: "16px",
                                fontWeight: "600",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {`Showing ${searchShowingCount} of ${searchTotalCount} results`}
                            </h3>
                            <SearchFilterPills {...activeSearchParams} />
                          </div>
                        </>
                      )
                    )}
                  </div>
                )}
              </div>
            )}
            <div className="jobs-outer-container">
              {hasSearched ? (
                <div className="search-results-container">
                  {renderChatMessages()}
                  <div className="search-box-bottom">
                    <GlobalSearchBox
                      value={searchQuery}
                      onChange={handleInputChange}
                      onSearch={handleSearch}
                      placeholder="Search for 'Frontend Developer Job at Texas, USA'"
                      searchTitle="VybogTAL Chat"
                      buttonLabel="Search"
                      inputsectionstylewrap={{ paddingBottom: "2px" }}
                      inputsectionstyle={{ paddingTop: "1px" }}
                      askmeanythingOnKeyDown={(e) => {
                        if (e.key === "Enter" && !e.shiftKey) {
                          e.preventDefault();
                          handleSearch();
                        }
                      }}
                      isSearchLoading={isInitialLoading}
                    />
                  </div>
                </div>
              ) : (
                <>
                  {isInitialLoading || isCreatingJob || !isFetchCompleted ? (
                    trackedViewTab === 1 ? (
                      renderCepheaLoader()
                    ) : (
                      <div
                        className="grouped-candidates-container"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          flex: 1,
                          overflowY: "auto",
                          paddingTop: "4px",
                        }}
                      >
                        <div className="jobs-table-list-card-container">
                          {Array.from({ length: 10 }).map((_, idx) => (
                            <DynamicSkeleton
                              key={idx}
                              variant="rectangular"
                              dimensions={{
                                width: "95%",
                                height: "200px",
                                sx: {
                                  borderRadius: "16px",
                                  border: "1px solid #e0e0e0",
                                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                  padding: "16px",
                                },
                              }}
                              spacing={2}
                            />
                          ))}
                        </div>
                      </div>
                    )
                  ) : (
                    <>
                      {jobsList.length > 0 ? (
                        <>
                          {trackedViewTab === 0 ? (
                            <div
                              className="grouped-candidates-container"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                flex: 1,
                                overflowY: "auto",
                                paddingTop: "4px",
                              }}
                            >
                              <div className="jobs-table-list-card-container">
                                {jobsList.map((job, index) => {
                                  const isSelected =
                                    isSelectMode &&
                                    selectedJobs.some((j) => j.id === job.id);
                                  return (
                                    <div
                                      className={`job-card-outer-container ${isSelected ? "selected" : ""}`}
                                      ref={
                                        index === jobsList.length - 1
                                          ? lastElement
                                          : null
                                      }
                                      key={index + "_outer"}
                                      onClick={(e) => {
                                        if (isSelectMode) {
                                          handleJobSelect(job, e);
                                        }
                                      }}
                                      style={{
                                        cursor: isSelectMode
                                          ? "pointer"
                                          : "default",
                                        backgroundColor: isSelected
                                          ? "rgba(104, 96, 238, 0.1)"
                                          : "transparent",
                                        border: isSelected
                                          ? "1px solid rgba(104, 96, 238, 0.5)"
                                          : "1px solid transparent",
                                        borderRadius: "12px",
                                      }}
                                    >
                                      <JobsCard
                                        key={index}
                                        jobId={job.id}
                                        title={job.title}
                                        subTitle={job.subTitle}
                                        priority={getPriorityLabel(
                                          job.priority,
                                        )}
                                        role={job.subTitle}
                                        minYearsExperience={
                                          job.min_years_experience
                                        }
                                        maxYearsExperience={
                                          job.max_years_experience
                                        }
                                        experience={job.years_experience}
                                        jobtype={job.job_type}
                                        actionText={true}
                                        viewJob={job.viewJob}
                                        skills={job.skills}
                                        minSalary={job.salary_min}
                                        maxSalary={job.salary_max}
                                        client={applyEllipsis(
                                          job?.client?.name,
                                          15,
                                        )}
                                        jobRole={job?.job_role}
                                        tags={job.tags}
                                        location={job.location}
                                        client_contact_person={applyEllipsis(
                                          job?.client_contact
                                            ? job?.client_contact?.name
                                            : job?.client?.contact_person,
                                          10,
                                        )}
                                        cardbackgroundColor="linear-gradient( rgb(66 185 120 / 31%), #D6FFE8)"
                                        cardColor="rgb(8 104 29)"
                                        skillbackgroundColor="rgb(12 122 51 / 74%)"
                                        skillColor="#fff"
                                        isActive={job.active}
                                        onStatusToggle={handleJobStatusToggle}
                                        isSelectMode={isSelectMode}
                                        isSelected={isSelected}
                                        handleCardSelect={() =>
                                          handleJobSelect(job)
                                        }
                                        viewJobEventHandler={(e) => {
                                          e.stopPropagation();
                                          handleOpenJobsSideContainer(
                                            job,
                                            index,
                                            "Job Details",
                                          );
                                        }}
                                        assignCandidateEventHandler={(e) => {
                                          e.stopPropagation();
                                          handleOpenJobsSideContainer(
                                            job,
                                            index,
                                            "Assigned Candidates",
                                          );
                                        }}
                                        editJobEventHandler={(e) => {
                                          e.stopPropagation();
                                          if (!isSelectMode) {
                                            setActiveTab("Job Details");
                                            handleOpenJobsSideContainer(
                                              job,
                                              index,
                                              "Job Details",
                                            );
                                            setIsEditingJob(true);
                                          }
                                        }}
                                        matchPercentage={
                                          hasSearchedJobs || isSearchMode
                                            ? job.match_percentage
                                            : undefined
                                        }
                                      />
                                    </div>
                                  );
                                })}
                                {isLoadingMore && (
                                  <>
                                    {Array.from({ length: 10 }).map(
                                      (_, idx) => (
                                        <DynamicSkeleton
                                          key={`scroll-skeleton-${idx}`}
                                          variant="rectangular"
                                          dimensions={{
                                            width: "95%",
                                            height: "200px",
                                            sx: {
                                              borderRadius: "16px",
                                              border: "1px solid #e0e0e0",
                                              boxShadow:
                                                "0 2px 4px rgba(0, 0, 0, 0.1)",
                                              padding: "16px",
                                            },
                                          }}
                                        />
                                      ),
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          ) : (
                            <>
                              {trackedViewTab === 1 && (
                                <div className="jobs-table-results">
                                  <Table
                                    key={`jobs-table-${jobsList.length}`}
                                    columns={
                                      hasSearchedJobs || isSearchMode
                                        ? searchJobColumnsDefinition
                                        : jobColumnsDefinition
                                    }
                                    data={jobsList}
                                    highlightOnHover
                                    pagination={true}
                                    paginationServer={
                                      hasSearchedJobs || isSearchMode
                                    }
                                    paginationTotalRows={
                                      hasSearchedJobs || isSearchMode
                                        ? searchTotalCount
                                        : undefined
                                    }
                                    paginationPerPage={10}
                                    paginationRowsPerPageOptions={[10]}
                                    currentPage={jobTablePage}
                                    onChangePage={handleJobTablePageChange}
                                    fixedHeader
                                    fixedHeaderScrollHeight="calc(100vh - 365px)"
                                    progressPending={
                                      (hasSearchedJobs || isSearchMode) &&
                                      isLoadingMore
                                    }
                                    dataNotFoundMessage="No jobs found."
                                  />
                                </div>
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {hasSearchedJobs && jobsList.length === 0 && (
                            <div className="no-pipeline-animation">
                              <div className="no-pipeline-text">
                                No jobs found matching your search criteria. Try
                                adjusting your filters.
                              </div>
                              <AnimationPlayer
                                animationSrc={RobatAnimation}
                                playerHeight="300px"
                                playerWidth="300px"
                              />
                            </div>
                          )}
                          {currentFilter === "active" &&
                            !hasActiveJobs &&
                            hasInactiveJobs && (
                              <div className="no-pipeline-animation">
                                <div className="no-pipeline-text">
                                  There are currently no active jobs available.
                                </div>
                                <AnimationPlayer
                                  animationSrc={sendIconDarkAnimation}
                                  playerHeight="300px"
                                  playerWidth="300px"
                                />
                              </div>
                            )}

                          {currentFilter === "inactive" &&
                            !hasInactiveJobs &&
                            hasActiveJobs && (
                              <div className="no-pipeline-animation">
                                <div className="no-pipeline-text">
                                  There are no inactive jobs right now.
                                </div>
                                <AnimationPlayer
                                  animationSrc={sendIconDarkAnimation}
                                  playerHeight="300px"
                                  playerWidth="300px"
                                />
                              </div>
                            )}

                          {!hasActiveJobs && !hasInactiveJobs && (
                            <div className="workspace-outer-main-container">
                              <div className="workspace-outer-container">
                                <div
                                  className="create-text-content"
                                  style={{
                                    textAlign: "center",
                                    marginTop: "100px",
                                  }}
                                >
                                  {createdByUserId ? (
                                    <>
                                      <h4
                                        style={{
                                          textAlign: "center",
                                          marginBottom: "-20px",
                                        }}
                                      >
                                        {createdByUserId === userDetails?.id
                                          ? "You haven't created any jobs yet."
                                          : "No jobs found for the selected user."}
                                      </h4>
                                      <AnimationPlayer
                                        animationSrc={RobatAnimation}
                                        playerHeight="300px"
                                        playerWidth="300px"
                                      />
                                    </>
                                  ) : (
                                    <>
                                      <img
                                        src={
                                          isDarkMode
                                            ? createDarkJobIcon
                                            : createDarkJobIcon
                                        }
                                        alt="InterviewIcon"
                                        className="interview-icon"
                                        style={{
                                          marginBottom: "-40px",
                                          marginLeft: "90px",
                                        }}
                                      />
                                      <h3>
                                        Create a{" "}
                                        <span className="inner-span">
                                          Job Posting
                                        </span>
                                      </h3>
                                      <p>
                                        Create a job posting and start assigning
                                        suitable candidates to be scheduled for
                                        interviews
                                      </p>
                                    </>
                                  )}
                                  {!MemberAccess && (
                                    <div className="client-workspace-button-container">
                                      <Button
                                        label="Create Job"
                                        event={handleOpenIJobGeneration}
                                        className="create-button"
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
      {selectedJob && (
        <JobsDetailsContainer
          isOpen={jobsSideContainerOpen}
          onClose={handleCloseJobsSideContainer}
          selectedJob={selectedJob}
          isEditingJob={isEditingJob}
          setIsEditingJob={setIsEditingJob}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          formik={formik}
          recruiterOptions={recruiterMultiSelectOptions}
          onRecruiterSearch={handleRecruiterSearch}
          onAssignedToChange={handleJobAssignedToChange}
          isLoadingRecruiters={isLoadingMembers}
          priority={getPriorityLabel(priority)}
          sideDialogformik={sideDialogformik}
          editedJobData={editedJobData}
          handleEditJob={handleEditJob}
          handleJobChange={handleJobChange}
          saveJobChanges={saveJobChanges}
          handleDeleteJob={handleOpenDeleteJobDiolog}
          showDeleteJobButton={canDeleteJob}
          resetJobEdit={resetJobEdit}
          hasSearched={hasSearched}
          jobDetails={jobDetails}
          hideSearchBox={hasSearched}
          isFetchingRecommendedCandidates={isFetchingRecommendedCandidates}
          recommendedCandidateIds={recommendedCandidateIds}
          onAssignedCountChange={assignedCountChange}
          showJobDetailsTab={true}
          showAssignedCandidatesTab={true}
          showRecommendedCandidatesTab={true}
          jobId={selectedJob?.id}
          assignedCount={assignedCount}
          setAssignedCount={setAssignedCount}
        />
      )}
      <SidePopup
        isOpen={isModalOpenJobGeneration}
        onClose={handleCloseJobGeneration}
        title="VybogTAL Job Generation"
        sidePopupWidth={"44%"}
      >
        <div className="job-popup-container1">
          <div className="create-job-fields-container">
            <div className="textfield-input-container">
              <DynamicTextField
                label={"Job Title"}
                placeholder={"e.g., Senior Frontend Developer"}
                value={jgFormik.values.genJobTitle}
                className="textfield-input"
                name={"genJobTitle"}
                onChange={jgFormik.handleChange}
                onBlur={jgFormik.handleBlur}
                error={
                  jgFormik.touched.genJobTitle && jgFormik.errors.genJobTitle
                }
                errorMessage={jgFormik.errors.genJobTitle}
                required={true}
                containerStyle={{ width: "100%", marginBottom: "15px" }}
              />
            </div>
          </div>
          <div className="job-client-fields-container">
            <div style={{ width: "100%" }}>
              <div className="skill-header">
                <div className="skill-title">
                  <h3
                    className="desc-inner-header textfield-label"
                    style={{ margin: 0 }}
                  >
                    {isHiringTeamTenant ? "Hiring Team" : "Client"}
                  </h3>
                  <span className="required-asterisk">*</span>
                </div>
              </div>
              <DynamicAutocomplete
                onChange={(value) => {
                  setJobGenClient(value || null);
                  jgFormik.setFieldValue("genClientID", value?.value || "");
                  jgFormik.setFieldValue("JobClientContactID", "");
                  jgFormik.setFieldTouched("JobClientContactID", false, false);
                  setClientContacts([]);
                }}
                onBlur={() => {
                  jgFormik.setFieldTouched("genClientID", true);
                }}
                error={
                  jgFormik.touched.genClientID &&
                  Boolean(jgFormik.errors.genClientID) &&
                  !jgFormik.values.genClientID
                }
                errorMessage={
                  jgFormik.touched.genClientID &&
                  jgFormik.errors.genClientID &&
                  !jgFormik.values.genClientID
                    ? jgFormik.errors.genClientID
                    : ""
                }
                value={
                  jgFormik.values.genClientID
                    ? jobGenClient?.value === jgFormik.values.genClientID
                      ? jobGenClient
                      : clientList.find(
                          (client) =>
                            client.value === jgFormik.values.genClientID,
                        ) || null
                    : null
                }
                placeholder={"Begin typing..."}
                onInputChange={handleClientInputChange}
                onOpen={handleClientOpen}
                noOptionsText={
                  jobGenNoClients ? "No clients..." : "No options..."
                }
                options={clientList}
                loading={jobGenClientLoading}
                sx={{
                  mt: "5px",
                  ".MuiOutlinedInput-root": {
                    borderRadius: "12px",
                    height: "40px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "1px solid var(--border__color) !important",
                      borderRadius: "12px",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#6860ee",
                      borderRadius: "12px",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#7a70f2",
                      borderRadius: "12px",
                    },
                  },
                  ".MuiInputBase-input": {
                    color: "var(--header__color)",
                    padding: "8px 12px !important",
                    height: "40px",
                    fontFamily: "Satoshi !important",
                  },
                }}
                slotProps={{
                  paper: {
                    sx: {
                      backgroundColor: "var(--body__background)",
                      color: "var(--header__color)",
                      borderRadius: "12px",
                      boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
                      border: "1px solid var(--border__color)",
                    },
                  },
                  listbox: {
                    sx: {
                      "& li": {
                        fontSize: "14px",
                        fontWeight: 500,
                        padding: "8px 16px",
                        color: "var(--header__color)",
                        "&:hover": {
                          backgroundColor: "rgba(0,0,0,0.04)",
                        },
                      },
                    },
                  },
                }}
                required={true}
              />
            </div>
          </div>
          {isHiringTeamTenant ? null : (
            <div className="col2 job-client-contact-openings-row">
              {jgFormik.values.genClientID && (
                <SelectInput
                  placeholder="Select"
                  options={clientContacts}
                  name="JobClientContactID"
                  value={jgFormik.values.JobClientContactID}
                  onChange={(e) => {
                    jgFormik.handleChange(e);
                    jgFormik.setFieldValue(
                      "JobClientContactID",
                      e.target.value,
                    );
                    jgFormik.setFieldTouched("JobClientContactID", true);
                  }}
                  onBlur={(e) => {
                    jgFormik.handleBlur(e);
                    jgFormik.setFieldTouched("JobClientContactID", true);
                  }}
                  label={
                    isHiringTeamTenant
                      ? "Hiring Team Contact"
                      : "Client Contact"
                  }
                  error={
                    jgFormik.touched.JobClientContactID &&
                    Boolean(jgFormik.errors.JobClientContactID) &&
                    !jgFormik.values.JobClientContactID
                  }
                  errorMessage={
                    jgFormik.touched.JobClientContactID &&
                    jgFormik.errors.JobClientContactID &&
                    !jgFormik.values.JobClientContactID
                      ? jgFormik.errors.JobClientContactID
                      : ""
                  }
                  wrapperStyle={{
                    display: "flex",
                    width: "100%",
                    marginBottom: "15px",
                  }}
                  labelStyle={{
                    fontSize: "16px",
                    fontWeight: 600,
                    width: "fit-content",
                    marginBottom: "12px",
                  }}
                  labelKey="label"
                  labelValue="value"
                />
              )}

              <div style={{ width: "100%" }}>
                <div className="no-op-skill-header">
                  <div className="no-op-skill-title">
                    <h3
                      className="desc-inner-header textfield-label"
                      style={{ margin: 0 }}
                    >
                      Number of openings
                    </h3>
                    <span className="required-asterisk">*</span>
                  </div>
                </div>
                <DynamicTextField
                  placeholder={"e.g. 2"}
                  value={jgFormik.values.genNumOp}
                  name={"genNumOp"}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || /^\d+$/.test(value)) {
                      jgFormik.handleChange(e);
                    }
                  }}
                  onBlur={jgFormik.handleBlur}
                  error={jgFormik.touched.genNumOp && jgFormik.errors.genNumOp}
                  errorMessage={jgFormik.errors.genNumOp}
                  containerStyle={{ width: "100%", marginBottom: "15px" }}
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    onKeyPress: (e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    },
                  }}
                />
              </div>
            </div>
          )}

          <div className="col2">
            <DynamicTextField
              label={"Job Role"}
              placeholder={"e.g. Marketing, Sales, or Design"}
              value={jgFormik.values.genJobRole}
              name={"genJobRole"}
              onChange={jgFormik.handleChange}
              onBlur={jgFormik.handleBlur}
              error={jgFormik.touched.genJobRole && jgFormik.errors.genJobRole}
              errorMessage={jgFormik.errors.genJobRole}
              required={true}
              containerStyle={{ width: "100%" }}
            />
            <SelectInput
              placeholder="Select"
              options={staticJobTypes}
              name="genJobType"
              value={jgFormik.values.genJobType}
              onChange={(e) => {
                jgFormik.handleChange(e);
                jgFormik.setFieldTouched("genJobType", true);
              }}
              onBlur={(e) => {
                jgFormik.handleBlur(e);
                jgFormik.setFieldTouched("genJobType", true);
              }}
              label="Job Type"
              error={
                jgFormik.touched.genJobType &&
                Boolean(jgFormik.errors.genJobType) &&
                !jgFormik.values.genJobType
              }
              errorMessage={
                jgFormik.touched.genJobType &&
                jgFormik.errors.genJobType &&
                !jgFormik.values.genJobType
                  ? jgFormik.errors.genJobType
                  : ""
              }
              required={true}
              wrapperStyle={{
                display: "flex",
                width: "100%",
                marginBottom: "15px",
              }}
              labelStyle={{
                fontSize: "16px",
                fontWeight: 600,
                width: "fit-content",
                marginBottom: "12px",
              }}
            />
          </div>
          <div className="col2">
            <SelectInput
              defaultOption="Priority"
              options={priority}
              defaultOptionStyle={{
                color: "var(--text-secondary)",
                opacity: 0.7,
              }}
              name="genJobPriority"
              value={jgFormik.values.genJobPriority}
              onChange={(e) => {
                jgFormik.handleChange(e);
                jgFormik.setFieldTouched("genJobPriority", true);
              }}
              onBlur={(e) => {
                jgFormik.handleBlur(e);
                jgFormik.setFieldTouched("genJobPriority", true);
              }}
              label="Job Priority"
              error={
                jgFormik.touched.genJobPriority &&
                Boolean(jgFormik.errors.genJobPriority) &&
                !jgFormik.values.genJobPriority
              }
              errorMessage={
                jgFormik.touched.genJobPriority &&
                jgFormik.errors.genJobPriority &&
                !jgFormik.values.genJobPriority
                  ? jgFormik.errors.genJobPriority
                  : ""
              }
              required={true}
              wrapperStyle={{
                display: "flex",
                width: "100%",
                marginBottom: "15px",
              }}
              labelStyle={{
                fontSize: "16px",
                fontWeight: 600,
                width: "fit-content",
                marginBottom: "12px",
              }}
            />
            <DynamicTextField
              label={"Job Location"}
              placeholder={"e.g. San Francisco, CA"}
              value={jgFormik.values.genJobLocation}
              name={"genJobLocation"}
              onChange={jgFormik.handleChange}
              onBlur={jgFormik.handleBlur}
              error={
                jgFormik.touched.genJobLocation &&
                jgFormik.errors.genJobLocation
              }
              errorMessage={jgFormik.errors.genJobLocation}
              required={true}
              containerStyle={{ width: "100%" }}
            />
          </div>
          <div className="col2">
            <div style={{ width: "100%" }}>
              <div className="skill-title" style={{ marginBottom: "8px" }}>
                <h3
                  className="desc-inner-header textfield-label"
                  style={{ margin: 0 }}
                >
                  Years of Experience
                </h3>
                <span className="required-asterisk">*</span>
              </div>
              <div style={{ display: "flex", gap: "10px", marginTop: "-8px" }}>
                <div style={{ flex: 1 }}>
                  <DynamicTextField
                    placeholder={"Min (e.g. 3)"}
                    value={jgFormik.values.genMinYearsExperience}
                    name={"genMinYearsExperience"}
                    onChange={jgFormik.handleChange}
                    onBlur={jgFormik.handleBlur}
                    error={
                      jgFormik.touched.genMinYearsExperience &&
                      jgFormik.errors.genMinYearsExperience
                    }
                    errorMessage={jgFormik.errors.genMinYearsExperience}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <DynamicTextField
                    placeholder={"Max (e.g. 5)"}
                    value={jgFormik.values.genMaxYearsExperience}
                    name={"genMaxYearsExperience"}
                    onChange={jgFormik.handleChange}
                    onBlur={jgFormik.handleBlur}
                    error={
                      jgFormik.touched.genMaxYearsExperience &&
                      jgFormik.errors.genMaxYearsExperience
                    }
                    errorMessage={jgFormik.errors.genMaxYearsExperience}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col2">
            <div style={{ width: "100%" }}>
              <div className="skill-title">
                <h3
                  className="desc-inner-header textfield-label"
                  style={{ margin: 0 }}
                >
                  Salary Min
                </h3>
                <CustomTooltip
                  title={"Enter the minimum annual salary for this position"}
                  arrow
                >
                  <img
                    src={infoIcon}
                    alt="Action 2"
                    className="parser-table-action-icons"
                    style={{ margin: "4px 5px 0px 5px" }}
                  />
                </CustomTooltip>
              </div>
              <DynamicTextField
                placeholder={"Per annum (Min)"}
                value={jgFormik.values.genSalaryMin}
                name={"genSalaryMin"}
                onChange={jgFormik.handleChange}
                onBlur={jgFormik.handleBlur}
                error={
                  jgFormik.touched.genSalaryMin && jgFormik.errors.genSalaryMin
                }
                errorMessage={jgFormik.errors.genSalaryMin}
              />
            </div>
            <div style={{ width: "100%" }}>
              <div className="skill-title">
                <h3
                  className="desc-inner-header textfield-label"
                  style={{ margin: 0 }}
                >
                  Salary Max
                </h3>
                <CustomTooltip
                  title={"Enter the maximum annual salary for this position"}
                  arrow
                >
                  <img
                    src={infoIcon}
                    alt="Action 2"
                    className="parser-table-action-icons"
                    style={{ margin: "4px 5px 0px 5px" }}
                  />
                </CustomTooltip>
              </div>
              <DynamicTextField
                placeholder={"Per annum (Max)"}
                value={jgFormik.values.genSalaryMax}
                name={"genSalaryMax"}
                onChange={jgFormik.handleChange}
                onBlur={jgFormik.handleBlur}
                error={
                  jgFormik.touched.genSalaryMax && jgFormik.errors.genSalaryMax
                }
                errorMessage={jgFormik.errors.genSalaryMax}
              />
            </div>
          </div>
          <div>
            <div className="skill-header">
              {" "}
              <div className="skill-title" style={{ marginTop: "9px" }}>
                <h3
                  className="desc-inner-header textfield-label"
                  style={{ margin: 0 }}
                >
                  Skills
                </h3>
                <span className="required-asterisk">*</span>
                <CustomTooltip
                  title={
                    "Type skill(s) and hit Enter or choose from the dropdown"
                  }
                  arrow
                >
                  {" "}
                  <img
                    src={infoIcon}
                    alt="Action 2"
                    className="parser-table-action-icons"
                    style={{ margin: "4px 5px 0px 5px" }}
                  />
                </CustomTooltip>
              </div>
            </div>

            <AutoComplete
              key={`auto-complete-${autoCompleteKey}`}
              multiple
              placeholder="e.g. JavaScript, React, Node.js, Machine Learning"
              // options={skills.filter((skill) => {
              //   const selectedSkills = Array.isArray(
              //     jgFormik.values.genJobskills,
              //   )
              //     ? jgFormik.values.genJobskills
              //     : [];
              //   return !selectedSkills.some(
              //     (selectedSkill) =>
              //       selectedSkill.toLowerCase() === skill.title.toLowerCase(),
              //   );
              // })}
              tags={true}
              name="genJobskills"
              value={jgFormik.values.genJobskills || []}
              onChange={(selectedOptions) => {
                const validSkills = selectedOptions
                  .map((option) =>
                    typeof option === "string" ? option : option.title,
                  )
                  .filter((option) => option.trim() !== "");

                const uniqueSkills = validSkills.filter(
                  (skill, index, self) =>
                    index ===
                    self.findIndex(
                      (s) => s.toLowerCase() === skill.toLowerCase(),
                    ),
                );

                jgFormik.setFieldValue("genJobskills", uniqueSkills);
              }}
              onBlur={() => jgFormik.setFieldTouched("genJobskills", true)}
              InputWrapperStyle={{
                height: "100px",
                color: "var(--header__color) !important",
                overflowY: "auto",
                padding: "10px",
                marginBottom: "15px",
              }}
              showClearAll={true}
              error={
                jgFormik.touched.genJobskills && jgFormik.errors.genJobskills
              }
              errorMessage={jgFormik.errors.genJobskills}
            />
          </div>
          {!jgFormik.values.generateDescription ? (
            <div>
              <div className="job-description-label">
                <div className="skill-title">
                  {" "}
                  <span
                    className="desc-inner-header textfield-label"
                    style={{ margin: 0 }}
                  >
                    Job Description
                  </span>
                </div>
                <div style={{ display: "flex", gap: "5px" }}>
                  <ToggleSwitcher
                    icon={AIJobDescriptionIcon}
                    label="Generate using"
                    labelStyle={{
                      textTransform: "none",
                      color: "var(--text_color)",
                    }}
                    highlightText={"AI"}
                    highlightTextStyle={{ color: "#6860EE", marginLeft: "5px" }}
                    name="generateDescription"
                    value={jgFormik.values.generateDescription}
                    onChange={jgFormik.setFieldValue}
                  />
                </div>
              </div>
              <span className="job-description-sub-label">
                Enter the job description
              </span>
              <TextArea
                placeholder={
                  "For e.g. Senior Backend Engineer to own our ingestion pipeline.."
                }
                className="ai-search-textfield textfield-label"
                name="genJobdescription"
                value={jgFormik.values.genJobdescription}
                onChange={jgFormik.handleChange}
                onBlur={() =>
                  jgFormik.setFieldTouched("genJobdescription", true)
                }
                error={
                  jgFormik.touched.genJobdescription &&
                  jgFormik.errors.genJobdescription
                }
                errorMessage={jgFormik.errors.genJobdescription}
                style={{ marginTop: "10px" }}
              />
            </div>
          ) : (
            <div>
              <div className="job-description-label">
                <div className="skill-title">
                  {" "}
                  <span
                    className="desc-inner-header textfield-label"
                    style={{ margin: 0 }}
                  >
                    Job Description Brief (optional)
                  </span>
                </div>
                <div style={{ display: "flex", gap: "5px" }}>
                  <ToggleSwitcher
                    icon={AIJobDescriptionIcon}
                    label="Generate using"
                    labelStyle={{
                      textTransform: "none",
                      color: "var(--text_color)",
                    }}
                    highlightText={"AI"}
                    highlightTextStyle={{ color: "#6860EE", marginLeft: "5px" }}
                    name="generateDescription"
                    value={jgFormik.values.generateDescription}
                    onChange={jgFormik.setFieldValue}
                  />
                </div>
              </div>
              <span className="job-description-sub-label">
                Enter a few details. VybogTAL will generate the full job
                description.
              </span>
              <TextArea
                placeholder={
                  "For e.g. Remote, React, Node.js, AWS, Healthcare domain, On-call rotation"
                }
                className="ai-search-textfield textfield-label"
                name="genJobdescription"
                value={jgFormik.values.genJobdescription}
                onChange={jgFormik.handleChange}
                onBlur={() =>
                  jgFormik.setFieldTouched("genJobdescription", true)
                }
                error={
                  jgFormik.touched.genJobdescription &&
                  jgFormik.errors.genJobdescription
                }
                errorMessage={jgFormik.errors.genJobdescription}
                style={{ marginTop: "10px" }}
              />
            </div>
          )}
          <div style={{ width: "100%", marginBottom: "15px" }}>
            <h3
              className="desc-inner-header textfield-label"
              style={{
                margin: "0 0 12px 0",
                fontSize: "16px",
                fontWeight: 600,
              }}
            >
              Assign Recruiters
            </h3>
            <DynamicMultipleSelectCheckmarks
              options={recruiterMultiSelectOptions}
              label=""
              labelKey="label"
              valueKey="value"
              value={jgFormik.values.genAssignedTo}
              onChange={handleAssignedToChange}
              onSearchChange={handleRecruiterSearch}
              loading={isLoadingMembers}
              placeholder="Select Recruiters"
              width="100%"
            />
          </div>
          <div>
            <div className="skill-header" style={{ marginTop: "10px" }}>
              <div className="skill-title">
                {" "}
                <h3
                  className="desc-inner-header textfield-label"
                  style={{ margin: 0 }}
                >
                  Tags
                </h3>
                {/* <span className="required-asterisk">*</span> */}
                <CustomTooltip title={"Custom tags for better search"} arrow>
                  {" "}
                  <img
                    src={infoIcon}
                    alt="Action 2"
                    className="parser-table-action-icons"
                    style={{ margin: "4px 5px 0px 5px" }}
                  />
                </CustomTooltip>
              </div>
            </div>
            <AutoComplete
              key={`auto-complete-tags-${autoCompleteKey}`}
              multiple
              placeholder="Type custom tags and hit Enter (e.g. 'remote', 'full-time', 'senior')"
              options={[]}
              tags={true}
              name="genJobtags"
              value={jgFormik.values.genJobtags || []}
              onChange={(selectedOptions) => {
                const validTags = selectedOptions
                  .map((option) =>
                    typeof option === "string" ? option : option.title,
                  )
                  .filter((option) => option.trim() !== "");

                const uniqueTags = validTags.filter(
                  (tag, index, self) =>
                    index ===
                    self.findIndex(
                      (t) => t.toLowerCase() === tag.toLowerCase(),
                    ),
                );

                jgFormik.setFieldValue("genJobtags", uniqueTags);
              }}
              onBlur={(event) => {
                jgFormik.setFieldTouched("genJobtags", true);
                const { value } = event.target;
                if (value) {
                  const newTags = value
                    .split(",")
                    .map((tag) => tag.trim())
                    .filter(Boolean);
                  const currentTags = jgFormik.values.genJobtags || [];
                  const combined = [...currentTags, ...newTags];
                  const uniqueTags = combined.filter(
                    (tag, index, self) =>
                      index ===
                      self.findIndex(
                        (t) => t.toLowerCase() === tag.toLowerCase(),
                      ),
                  );
                  jgFormik.setFieldValue("genJobtags", uniqueTags);
                }
              }}
              InputWrapperStyle={{
                height: "100px",
                color: "var(--header__color) !important",
                overflowY: "auto",
                padding: "10px",
                marginBottom: "10px",
              }}
              error={jgFormik.touched.genJobtags && jgFormik.errors.genJobtags}
              errorMessage={jgFormik.errors.genJobtags}
              showClearAll={true}
            />
          </div>
          <div className="create-client-button-container">
            <Button
              label="Cancel"
              event={handleCloseJobGeneration}
              backgroundColor="#6860ee"
              isCancel={true}
            />
            <Button
              label={isGenerating ? "Generating..." : "Generate Job"}
              event={generateJobDescription}
              disabled={isGenerating || !jgFormik.isValid}
              backgroundColor={
                isGenerating || !jgFormik.isValid ? "#c4c4c4" : "#6860ee"
              }
            />
          </div>
        </div>
      </SidePopup>
      <ConfirmationPopup
        isOpen={openConversationLimitPopup}
        onConfirm={() => {
          handleBackToList();
          setOpenConversationLimitPopup(false);
        }}
        title="Conversation limit reached."
        message="You have reached the limit of this conversation. Please start a new one"
        confirmLabel="New Chat"
        cancelLabel=""
      />
      <ConfirmationPopup
        isOpen={openJobDeleteDialog}
        onClose={() => setOpenJobDeleteDialog(false)}
        onConfirm={handleDeleteJob}
        title="Delete Job?"
        subTitle="Confirmation required"
        message={
          <span>
            This will delete{" "}
            <span
              style={{
                color: "#6665ea",
                fontWeight: "bold",
              }}
            >
              "{applyEllipsis(selectedJob?.title, 35)}"
            </span>
            Are you sure you want to delete this job? This action cannot be
            undone.
          </span>
        }
        cancelLabel="No, Cancel"
        confirmLabel="Yes, Delete"
        confirmButtonClass="popup-button-danger"
      />
      <VendorSelectionPopup
        isOpen={isVendorSelectionOpen}
        onClose={() => setIsVendorSelectionOpen(false)}
        onVendorSelect={handleVendorSelect}
        selectedJobs={selectedJobs}
      />
      {showMatchPercentagePopup && (
        <MatchPercentage onClose={() => setShowMatchPercentagePopup(false)} />
      )}
      {isAssignClientOpen && (
        <StandardPopup 
        isOpen={isAssignClientOpen}
        onClose={() => {
          setIsAssignClientOpen(false);
          defaultClientIdFormik.resetForm();
        }}
        onSubmit={() => setIsAssignClientOpen(false)}
        title="Select Client"
        subTitle="The selected client will be assigned to all parsed jobs."
        children={
          <DynamicAutocomplete
                onChange={(value) => {
                  setJobGenClient(value || null);
                  defaultClientIdFormik.setFieldValue("defaultClientId", value?.value || "");
                }}
                value={
                  defaultClientIdFormik.values.defaultClientId
                    ? jobGenClient?.value === defaultClientIdFormik.values.defaultClientId
                      ? jobGenClient
                      : clientList.find(
                          (client) =>
                            client.value === defaultClientIdFormik.values.defaultClientId,
                        ) || null
                    : null
                }
                placeholder={"Begin typing..."}
                onInputChange={handleClientInputChange}
                onOpen={handleClientOpen}
                noOptionsText={
                  jobGenNoClients ? "No clients..." : "No options..."
                }
                options={clientList}
                loading={jobGenClientLoading}
                sx={{
                  mt: "5px",
                  ".MuiOutlinedInput-root": {
                    borderRadius: "12px",
                    height: "40px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "1px solid var(--border__color) !important",
                      borderRadius: "12px",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#6860ee",
                      borderRadius: "12px",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#7a70f2",
                      borderRadius: "12px",
                    },
                  },
                  ".MuiInputBase-input": {
                    color: "var(--header__color)",
                    padding: "8px 12px !important",
                    height: "40px",
                    fontFamily: "Satoshi !important",
                  },
                }}
                slotProps={{
                  paper: {
                    sx: {
                      backgroundColor: "var(--body__background)",
                      color: "var(--header__color)",
                      borderRadius: "12px",
                      boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
                      border: "1px solid var(--border__color)",
                    },
                  },
                  listbox: {
                    sx: {
                      "& li": {
                        fontSize: "14px",
                        fontWeight: 500,
                        padding: "8px 16px",
                        color: "var(--header__color)",
                        "&:hover": {
                          backgroundColor: "rgba(0,0,0,0.04)",
                        },
                      },
                    },
                  },
                }}
              />
        }
        />
      )}
    </div>
  );
}

export default JobsTableList;
